

import { useEffect, useState } from 'react';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import axios from 'axios';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileLines } from '@fortawesome/free-solid-svg-icons';
import { Link, useNavigate } from 'react-router-dom'; // Import useNavigate
import report from '../../assets/images/report.png'; // Adjust the path as needed
import Driver from './Driver';
import UpdatedPavati from './UpdatedPavati';
import AlertMessage from '../../AlertMessage';
import loading2 from '../../assets/images/loading.jpg.gif';
import attachment from '../../assets/images/attachment.png';


const FeeForm = () => {
  const [isloading, setisloading] = useState(false);
  const [feetype, setFeetype] = useState('');
  const [amount, setAmount] = useState('');
  const [classType, setClassType] = useState('');
  const [schoolBus, setSchoolBus] = useState(false);
  // const [students, setStudents] = useState([]);
  // const [totalFee, setTotalFee] = useState(0);
  const [editIndex, setEditIndex] = useState(null);
  const [showRootAssignForm, setShowRootAssignForm] = useState(false);
  const [root, setRoot] = useState('');
  const [isHovered, setIsHovered] = useState(false);
  const [registerNo, setRegisterNo] = useState('');
  const [showFeeTypeForm, setShowFeeTypeForm] = useState(false);
  const udiseNumber = localStorage.getItem("udiseNumber");
  const [classes, setClasses] = useState([]);
  const [classCounts, setClassCounts] = useState({});
  const [fromtheway, setFromtheway] = useState("");
  const [thewayup, setThewayup] = useState("");
  const [data, setData] = useState([]);
  const [showNewAddForm, setShowNewAddForm] = useState(false);
  const [selectedClass, setSelectedClass] = useState('');
  const [filteredStudents, setFilteredStudents] = useState([]);
  const [amount1, setAmount1] = useState("");
  const [editMode, setEditMode] = useState(false); // Add this line
  const [editId, setEditId] = useState(null);     // Add this line
  const [roots, setRoots] = useState([]);
  const [selectedRegisterNo, setSelectedRegisterNo] = useState('');
  const [year, setYear] = useState('2025-2026');
  const [editCell, setEditCell] = useState('')
  const [stdType, setStdType] = useState('');
  const [selectedStudentSerialNo, setSelectedStudentSerialNo] = useState('');
  const [selectedStudentSerials, setSelectedStudentSerials] = useState([]);
  const [rootData, setRootData] = useState({});
  const [date, setDate] = useState(new Date().toISOString().split('T')[0]);
  const [invoiceNo, setInvoiceNo] = useState('');
  const [mylastInvoiceNo, setmylastInvoiceNo] = useState('');
  const [transactionValue, setTransactionValue] = useState("By Cash");
  const [serialNo, setSerialNo] = useState('');
  const [formKey, setFormKey] = useState(0); // State for reloading the form

  const [tableData, setTableData] = useState([]);
  const [showDriver, setShowDriver] = useState(false);
  const [selectedDivision, setSelectedDivision] = useState('');
  const [reportDataUpdated, setReportDataUpdated] = useState({});
  const [typedPayAmount, setTypedPayAmount] = useState({});
  const [typedPayAmountforupdatepavati, setTypedPayAmountforupdatepavati] = useState({});
  const [typedBeforepay, setTypedBeforepay] = useState({});
  const [selectedStudentSerialforcolor, setSelectedStudentSerialforcolor] = useState(null);

  const language = localStorage.getItem("language");
  const [searchInput, setSearchInput] = useState('');
  const [finYear, setFinYear] = useState('2025-2026');
  const [isDefaultYearLoaded, setIsDefaultYearLoaded] = useState(false);
  const userstatus = localStorage.getItem('userStatus');

  const [alertMessage, setAlertMessage] = useState("");
  const [showAlert, setShowAlert] = useState(false);

  const [paymentGatewayType, setPaymentGatewayType] = useState('');
  const [transactionId, setTransactionId] = useState('');
  const [checkNo, setCheckNo] = useState('');
  const [checkDate, setCheckDate] = useState('');
  const [ddNo, setddNo] = useState('');
  const [dddate, setdddate] = useState('');
  const [finYearStartDate, setFinYearStartDate] = useState('');
  const [finYearEndDate, setFinYearEndDate] = useState('');



  useEffect(() => {
    if (alertMessage) {
      setShowAlert(true);
      const timeoutId = setTimeout(() => {
        setShowAlert(false);
        setAlertMessage("");
      }, 3000);
      return () => clearTimeout(timeoutId);
    }
  }, [alertMessage]);

  const [showUpdatedPavatiButton, setShowUpdatedPavatiButton] = useState(false);

  const openIndexedDB = () => {
    return new Promise((resolve, reject) => {
      const request = indexedDB.open('SchoolManagementDB', 1); // Incremented version

      request.onerror = (event) => {
        console.error("IndexedDB error:", event.target.error);
        reject("Error opening IndexedDB");
      };

      request.onsuccess = (event) => {
        resolve(event.target.result);
      };

      request.onupgradeneeded = (event) => {
        const db = event.target.result;
        if (!db.objectStoreNames.contains('studentData')) {
          db.createObjectStore('studentData', { keyPath: 'id' });
        }
        if (!db.objectStoreNames.contains('defaultSettings')) {
          db.createObjectStore('defaultSettings', { keyPath: 'id' });
        }
        if (!db.objectStoreNames.contains('kirdWithFeeattach')) {
          db.createObjectStore('kirdWithFeeattach', { keyPath: 'id' });
        }
      };
    });
  };



  const filteredStudentList = filteredStudents.filter(student => {
    const fullName = `${student.stdName} ${student.stdFather} ${student.stdSurname}`.toLowerCase();
    return fullName.includes(searchInput.toLowerCase());
  });

  useEffect(() => {
    const fetchDefaultYear = async () => {
      try {
        const db = await openIndexedDB();
        const transaction = db.transaction(['defaultSettings'], 'readonly');
        const objectStore = transaction.objectStore('defaultSettings');
        const request = objectStore.get('defaultSettings');
        request.onsuccess = (event) => {
          const defaultSetting = event.target.result;
          if (defaultSetting) {
            setYear(defaultSetting.defaultYear || "2025-2026"); // Set the year from IndexedDB
            setFinYear(defaultSetting.defaultYear || "2025-2026"); // Set the financial year from IndexedDB
          } else {
            console.warn("No default settings found for the key 'defaultSettings'.");
          }
          setIsDefaultYearLoaded(true);
        };
        request.onerror = (event) => {
          console.error("Error fetching default settings:", event.target.error);
          setIsDefaultYearLoaded(true);
        };
      } catch (error) {
        console.error('Error fetching default year:', error);
        setIsDefaultYearLoaded(true);
      }
    };
    fetchDefaultYear();
  }, [udiseNumber]);

  useEffect(() => {
    if (finYear) {
      const [startYear, endYear] = finYear.split('-');
      const startDate = `${startYear}-04-01`; // Financial year starts April 1
      const endDate = `${endYear}-03-31`;     // Financial year ends March 31

      setFinYearStartDate(startDate);
      setFinYearEndDate(endDate);

      // Optionally reset date to a valid one within the financial year (e.g., today if valid, else start date)
      const today = new Date().toISOString().split('T')[0];
      const currentDate = (today >= startDate && today <= endDate) ? today : startDate;
      setDate(currentDate);
    }
  }, [finYear]); // Re-run whenever finYear changes (including initial default)


  const navigate = useNavigate();
  useEffect(() => {
    fetchData();
  }, [udiseNumber]);

  const handleReload = () => {
    setShowUpdatedPavatiButton(false)
    if (invoiceNo == mylastInvoiceNo) {

      setInvoiceNo(mylastInvoiceNo)
    } else if (invoiceNo == mylastInvoiceNo - 1) {

      setInvoiceNo(mylastInvoiceNo)
    } else {
      setInvoiceNo(mylastInvoiceNo + 1)
    }
    setStdType('');
    setSelectedRegisterNo(''); // Reset register number
    setSelectedClass(''); // Reset class selection
    setTableData([]); // Clear table data
    setFormKey(prevKey => prevKey + 1); // Trigger a re-render
    fetchDatafirst(); // Re-fetch the table data if needed
    setTransactionValue('By Cash');
    setSearchInput('');
  };


  const fetchData = async (selectedClass = '', selectedRegisterNo = '') => {
    const studentUrl = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/studentData.json`;
    const feeUrl = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/fees/${finYear}.json`;

    try {
      const [studentResponse, feeResponse] = await Promise.all([fetch(studentUrl), fetch(feeUrl)]);

      if (!studentResponse.ok || !feeResponse.ok) {
        throw new Error('Failed to fetch data');
      }

      let studentData = await studentResponse.json();
      let feeData = await feeResponse.json();


      studentData = studentData ? Object.fromEntries(Object.entries(studentData).filter(([key, value]) => value !== null && (value.isActive !== false || value.isActive === undefined))) : {};
      feeData = feeData ? Object.fromEntries(Object.entries(feeData).filter(([key, value]) => value !== null)) : {};

      const studentArray = Object.keys(studentData).map((key) => ({
        registerNo: key,
        ...studentData[key],
      }));

      const processedStudentArray = studentArray.map((student) => ({
        ...student,
        currentClass: student.currentClass || 'Unknown',
      }));

      let filteredStudents = processedStudentArray;

      if (selectedClass && selectedClass !== 'All' && selectedClass !== 'Unknown') {
        filteredStudents = filteredStudents.filter((student) => student.currentClass == selectedClass);
      } else if (selectedClass == 'Unknown') {
        filteredStudents = filteredStudents.filter((student) => student.currentClass == 'Unknown');
      }

      if (selectedRegisterNo) {
        filteredStudents = filteredStudents.filter((student) => student.registerNo == selectedRegisterNo.trim());
      }

      const feeArray = Object.keys(feeData).map((key) => ({
        id: key,
        ...feeData[key],
      }));

      const combinedData = filteredStudents.map((student) => {
        const fee = feeArray.find((f) => f.feetype == student.feetype);
        return {
          ...student,
          amount: fee ? fee.amount : '',
          feetype: fee ? fee.feetype : '',
          schoolBus: fee ? fee.schoolBus : false,
          currentClass: student.currentClass || '',

        };
      });

      const studentCountByClass = processedStudentArray.reduce((acc, student) => {
        acc[student.currentClass] = (acc[student.currentClass] || 0) + 1;
        return acc;
      }, {});

      studentCountByClass['All'] = studentArray.length; // Add total student count under "All"

      // const totalFee = combinedData.reduce((acc, student) => acc + Number(student.amount), 0);

      // setStudents(studentArray);
      setClassCounts(studentCountByClass);
      setFilteredStudents(combinedData);
      // setClasses([...new Set(studentArray.map((student) => student.currentClass))]);
      // setTotalFee(totalFee);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  const fetchClassDivData = async () => {
    try {
      const storedDivClasses = localStorage.getItem("classDiv");
      if (storedDivClasses) {
        const data = JSON.parse(storedDivClasses);

        const classList = [];
        const divisionList = {};

        for (const [className, value] of Object.entries(data)) {
          if (value === true) {
            classList.push(className);
            divisionList[className] = [];
          } else if (typeof value === 'object') {
            classList.push(className);
            divisionList[className] = Object.keys(value).filter(div => value[div]); // Get divisions that are true
          }
        }

        setClasses(classList);
        // setDivisionOptions(divisionList); 
      }
    } catch (error) {
      console.error("Error fetching classDiv data: ", error);
    }
  };

  useEffect(() => {
    fetchClassDivData();
  }, [udiseNumber]);


  const handleClassChange = (e) => {
    const selectedClass = e.target.value;
    setSelectedClass(selectedClass);
    fetchData(selectedClass, registerNo);
  };
  const sortClasses = (classes, language) => {
    const classOrder = {
      "Class I": 1,
      "Class II": 2,
      "Class III": 3,
      "Class IV": 4,
      "Class V": 5,
      "Class VI": 6,
      "Class VII": 7,
      "Class VIII": 8,
      "Class IX": 9,
      "Class X": 10,
      "Class XI": 11,
      "Class XII": 12,
      "इयत्ता पहिली": 1,
      "इयत्ता दुसरी": 2,
      "इयत्ता तिसरी": 3,
      "इयत्ता चौथी": 4,
      "इयत्ता पाचवी": 5,
      "इयत्ता सहावी": 6,
      "इयत्ता सातवी": 7,
      "इयत्ता आठवी": 8,
      "इयत्ता नववी": 9,
      "इयत्ता दहावी": 10,
      "इयत्ता अकरावी": 11,
      "इयत्ता बारावी": 12,
    };

    return classes.sort((a, b) => classOrder[a] - classOrder[b]);
  };

  const fetchDatafirst = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/fees/${finYear}.json`);
      const data = await response.json();
      if (data) {
        const formattedData = Object.keys(data).map(key => ({
          ...data[key],
          feetype: key
        }));
        setTableData(formattedData);
      } else {
        setTableData([]);
      }
    } catch (error) {
      console.error('Error fetching data:', error);
      setTableData([]);
    }
  };

  useEffect(() => {
    if (isDefaultYearLoaded) {
      fetchDatafirst();
    }
  }, [finYear, udiseNumber, isDefaultYearLoaded]);

  const getBaseFeetype = (feetype) => {
    const lastIndex = feetype.lastIndexOf('-');
    return lastIndex !== -1 ? feetype.substring(0, lastIndex) : feetype;
  };
  useEffect(() => {
    if (isDefaultYearLoaded) {
      fetchData(selectedClass, selectedRegisterNo);
    }
  }, [selectedClass, selectedRegisterNo, finYear, isDefaultYearLoaded]);




  const saveAccountTransaction = async (url, transactionData) => {
    try {
      const response = await fetch(url, {
        method: 'PUT', // Use PUT to create or update the account node
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(transactionData)
      });

      if (!response.ok) {
        throw new Error('Failed to save account transaction');
      }
      return true;
    } catch (error) {
      console.error('Account transaction error:', error);
      return false;
    }
  };

  const createAccountEntry = async (feeDetails, feeDetailsWithPayAmount, currentInvoiceNo, lastnaveNo, lastjamaNo) => {
    console.log("lastjamaNo", lastjamaNo);
    console.log("lastnaveNo", lastnaveNo);
    console.log("createAccountEntry created");

    // Check if typeofattach is "singlePavati"
    if (typeofattach !== "singlePavati") {
      console.log('Attachment type is not singlePavati - skipping account entry');
      return true; // Consider this successful for fee submission
    }

    if (!selectedKirdType && !selectedcreditKhate && !selecteddebitKhate) {
      console.log('Account details not configured - skipping account entry');
      return true; // Still consider this successful for fee submission
    }

    const totalPayAmount = feeDetailsWithPayAmount.reduce((total, fee) => total + (parseFloat(fee.payAmount) || 0), 0);

    const khateprakar = feeDetailsWithPayAmount[0].transaction;
    console.log("feeDetailsWithPayAmount31233-- ", feeDetailsWithPayAmount);

    const pavatiNojama = lastjamaNo + 1; // Increment lastjamaNo
    const pavatiNonave = lastnaveNo + 1; // Increment lastnaveNo

    const jamaTransactionData = {
      Amount: totalPayAmount,
      Debit1: selecteddebitKhate,
      Remark: `Amount transferred from Students fee. Invoice No: ${currentInvoiceNo}`,
      credit1: selectedcreditKhate,
      currenttime: new Date().toLocaleTimeString('en-GB', {
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false
      }),
      date: feeDetails.date,
      financialYear: year,
      khatePrakar: khateprakar,
      pavtiNo: pavatiNojama // Use the incremented pavatiNo
    };



    // Prepare transaction data for nave
    const naveTransactionData = {
      Amount: totalPayAmount,
      Debit1: selecteddebitKhate,
      Remark: `Amount transferred from Students fee. Invoice No: ${currentInvoiceNo}`,
      credit1: selectedcreditKhate,
      currenttime: new Date().toLocaleTimeString('en-GB', {
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false
      }),
      date: feeDetails.date,
      financialYear: year,
      khatePrakar: khateprakar,
      pavtiNo: pavatiNonave // Use the incremented pavatiNo
    };

    // Update only the jama node if debitKhate is empty and creditKhate has a value
    if (selecteddebitKhate === "" && selectedcreditKhate) {
      console.log('Updating jama node');
      const jamaUrl = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/account/kird/${selectedKirdType}/${year}/jama/${pavatiNojama}.json`;
      await saveAccountTransaction(jamaUrl, jamaTransactionData);
      // Update lastjamaNo
      await updateAccountCounters(null, pavatiNojama); // Increment only lastjamaNo
    }
    // Update only the nave node if creditKhate is empty and debitKhate has a value
    else if (selectedcreditKhate === "" && selecteddebitKhate) {
      console.log('Updating nave node');
      const naveUrl = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/account/kird/${selectedKirdType}/${year}/nave/${pavatiNonave}.json`;
      await saveAccountTransaction(naveUrl, naveTransactionData);
      // Update lastnaveNo
      await updateAccountCounters(pavatiNonave, null); // Increment only lastnaveNo
    } else {
      // Save the transaction in the jama node
      const jamaUrl = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/account/kird/${selectedKirdType}/${year}/jama/${pavatiNojama}.json`;
      await saveAccountTransaction(jamaUrl, jamaTransactionData);

      // Save the transaction in the nave node
      const naveUrl = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/account/kird/${selectedKirdType}/${year}/nave/${pavatiNonave}.json`;
      await saveAccountTransaction(naveUrl, naveTransactionData);

      // Update lastnaveNo and lastjamaNo
      await updateAccountCounters(pavatiNonave, pavatiNojama); // Increment both counters
    }
  };

  const updateAccountCounters = async (newNaveNo, newJamaNo) => {
    try {
      if (newNaveNo !== null) {
        // Update lastnaveNo
        const lastnaveUrl = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/account/kird/${selectedKirdType}/${year}/lastnaveNo.json`;
        await fetch(lastnaveUrl, {
          method: 'PUT',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ lastnaveNo: newNaveNo }) // Store as an object
        });
      }
      if (newJamaNo !== null) {  // Update lastjamaNo
        const lastjamaUrl = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/account/kird/${selectedKirdType}/${year}/lastjamaNo.json`;
        await fetch(lastjamaUrl, {
          method: 'PUT',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ lastjamaNo: newJamaNo }) // Store as an object
        });
      }
      return true;
    } catch (error) {
      console.error('Counter update error:', error);
      return false;
    }
  };





  const handleSendWhatsAppFeeReminder = async () => {
    const student = filteredStudents.find(s => s.serialNo === selectedStudentSerialNo);
    if (!student) {
      setAlertMessage("No student selected.");
      return;
    }

    try {
      setisloading(true);
      const configRes = await fetch(`${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/whatsappConfig.json`);
      const whatsappConfig = await configRes.json();

      if (!whatsappConfig || !whatsappConfig.enabled) {
        setAlertMessage('WhatsApp fees webhook is not configured or disabled for this school.');
        setisloading(false);
        return;
      }

      const fallbackWebhook = "https://webhook.whatapi.in/webhook/6a9127b6c277c1989c47cd73?number=91xxxxxxxxxx&message=fee,StudentName,Class,Division,DueDate,TotalFee,PaidAmount,PendingAmount,PaymentMode,SchoolName,ContactNumber";
      const webhookTemplate = whatsappConfig.feesWebhook || fallbackWebhook;
      const staffNumbers = whatsappConfig.feesStaffAlertsEnabled
        ? [...new Set((whatsappConfig.feesStaffNumbers || '').split(/[\s,;]+/).map(number => number.replace(/\D/g, '')).filter(Boolean).map(number => number.startsWith('91') ? number : `91${number}`))]
        : [];

      const schoolNameValue = localStorage.getItem('schoolName') || 'School';
      const contactNumber = localStorage.getItem('adminmob') || '-';

      const mobileNumber = student.fMobile || student.mobileNo || '';
      let phone = mobileNumber ? String(mobileNumber).trim().replace(/\D/g, '') : '';
      if (!phone) {
        setAlertMessage("Student mobile number not available.");
        setisloading(false);
        return;
      }
      if (!phone.startsWith('91')) phone = '91' + phone;

      const studentName = `${student.stdName || ''} ${student.stdFather || ''} ${student.stdSurname || ''}`.trim() || '-';
      const className = student.currentClass || '-';
      const divName = student.division || '-';
      
      const totalFee = tableData.reduce((sum, row) => sum + parseFloat(row.amount || 0), 0);
      const discountAmount = tableData.reduce((sum, row) => sum + parseFloat(row.discountAmount || 0), 0);
      const previousPaid = tableData.reduce((sum, row) => sum + parseFloat(row.beforePay || 0), 0);
      const currentPayAmount = tableData.reduce((sum, row) => sum + parseFloat(row.payAmount || 0), 0);
      const paidAmount = previousPaid + currentPayAmount;
      const pendingAmount = totalFee - discountAmount - paidAmount;
      
      const paymentMode = transactionValue || 'Online / Cash';
      const dueDate = 'As per school schedule';

      const [baseUrl, queryString] = webhookTemplate.split('?');
      const params = new URLSearchParams(queryString || '');
      
      params.set('number', phone);
      
      const messageVal = params.get('message') || '';
      const parts = messageVal.split(',');
      
      const replacedParts = parts.map((part) => {
          const trimmed = part.trim().toLowerCase();
          if (trimmed === 'studentname') return studentName;
          if (trimmed === 'class') return className;
          if (trimmed === 'division') return divName;
          if (trimmed === 'duedate') return dueDate;
          if (trimmed === 'totalfee') return totalFee.toString();
          if (trimmed === 'paidamount') return paidAmount.toString();
          if (trimmed === 'pendingamount') return pendingAmount.toString();
          if (trimmed === 'paymentmode') return paymentMode;
          if (trimmed === 'schoolname') return schoolNameValue;
          if (trimmed === 'contactnumber') return contactNumber;
          return part;
      });

      params.set('message', replacedParts.join(','));
      const url = baseUrl + '?' + params.toString().replace(/%2C/g, ',').replace(/\+/g, '%20');

      console.log('Sending fee reminder:', url);

      const recipientUrls = [url, ...staffNumbers.map(number => url.replace(/number=[^&]+/, `number=${number}`))];
      await Promise.all(recipientUrls.map(recipientUrl => fetch(recipientUrl, { method: 'GET', mode: 'no-cors' })));
      
      setAlertMessage("WhatsApp messages sent successfully!");
    } catch (err) {
      console.error('WhatsApp failed:', err);
      setAlertMessage("Failed to send WhatsApp messages.");
    } finally {
      setisloading(false);
    }
  };


  const handleSubmit = async (e) => {
    e.preventDefault();

    const feetypeToSave = schoolBus ? 'Bus Fee' : feetype;
    const amountToSave = schoolBus ? '' : amount;

    if (!feetypeToSave) {
      setAlertMessage('Feetype is required');
      return;
    }

    if (!amountToSave && !schoolBus) {
      setAlertMessage('Amount is required unless the school bus is checked');
      return;
    }

    // Check if the "School Bus" fee already exists for the selected class type
    const busFeeExists = tableData.some(row => row.classType === classType && row.schoolBus);

    if (schoolBus && busFeeExists) {
      setAlertMessage(`School Bus fee already exists for Class  ${classType}`);
      return;
    }

    // Create the fee type string based on the selected class
    //  const feeTypeWithClass = classType !== 'All' ? `${feetypeToSave}-${classType}` : feetypeToSave;
    //  const feeTypeWithClass = schoolBus ? 'Bus Fee' : (classType !== 'All' ? `${feetypeToSave}-${classType}` : feetypeToSave);

    const feeTypeWithClass = schoolBus ? 'Bus Fee' : (classType !== 'All' ? `${feetypeToSave}-${classType.replace(/\./g, '_')}` : feetypeToSave);
    const newStudent = {
      feetype: feeTypeWithClass, // Use the new fee type format
      amount: amountToSave,
      classType: schoolBus ? 'All' : classType,
      schoolBus,
    };

    try {
      const feesUrl = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/fees/${finYear}/${feeTypeWithClass}.json`; // Update the URL to use the new fee type format
      const response = await fetch(feesUrl, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(newStudent),
      });

      if (response.ok) {
        let totalStd = 0;
        if (classType === 'All') {
          totalStd = Object.values(classCounts).reduce((acc, curr) => acc + curr, 0);
        } else {
          totalStd = classCounts[classType] || 0;
        }

        const newRow = {
          feetype: feeTypeWithClass, // Use the new fee type format
          amount: amountToSave,
          classType,
          totalStd,
          schoolBus,
        };

        setTableData([...tableData, newRow]);
        clearForm();
        setAlertMessage('Data saved successfully!');
        fetchData();



      } else {
        throw new Error('Failed to save data.');
      }
    } catch (error) {
      console.error('Error saving data to Firebase:', error);
      setAlertMessage('Failed to save data. Please try again.');
    }
  };


  const handleStudentClick = async (studentSerialNo) => {
    setSelectedStudentSerialNo(studentSerialNo);
  };

  const handleRootAssign = () => {
    setShowRootAssignForm(true);
  };

  const handleRootAssign1 = () => {
    setShowNewAddForm(true);
  };

  const handleRootAssignSubmit = async (e) => {
    e.preventDefault();

    if (!root) {
      setAlertMessage('Please select a root');
      return;
    }

    // Ensure at least one student is selected
    if (selectedStudentSerials.length === 0) {
      setAlertMessage('Please select at least one student.');
      return;
    }

    // Prepare the selected students object
    const selectedStudents = selectedStudentSerials.reduce((acc, serialNo) => {
      acc[serialNo] = true;
      return acc;
    }, {});

    try {
      // Fetch all root data
      const allRootDataResponse = await axios.get(`${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/root/${finYear}.json`);
      const allRootData = allRootDataResponse.data;

      // Remove selected students from all other roots
      for (const rootId in allRootData) {
        if (rootId !== root) { // Skip the current root
          const rootData = allRootData[rootId];
          if (rootData.studentSerialNo) {
            selectedStudentSerials.forEach((serialNo) => {
              delete rootData.studentSerialNo[serialNo];
            });
            // Use PATCH to update only the affected fields
            await axios.patch(`${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/root/${finYear}/${rootId}.json`, rootData);
          }
        }
      }

      // Fetch the current root data for the selected root
      const currentRootDataResponse = await axios.get(`${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/root/${finYear}/${root}.json`);
      const currentRootData = currentRootDataResponse.data;

      // Update the selected root with new student serial numbers
      const updatedRootData = {
        ...currentRootData,
        studentSerialNo: {
          ...(currentRootData.studentSerialNo || {}),  // Ensure existing serial numbers are kept
          ...selectedStudents,  // Add new selected students
        },
      };

      // Use PATCH to update only studentSerialNo field
      await axios.patch(`${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/root/${finYear}/${root}.json`, updatedRootData);

      // Clear selections and close the form
      setSelectedStudentSerials([]);
      setRoot('');

      setAlertMessage('Students assigned to the selected root successfully');
    } catch (error) {
      console.error('Error updating root with selected students:', error);
      setAlertMessage('An error occurred while saving. Please try again.');
    }
  };

  useEffect(() => {
    const fetchRootData = async () => {
      try {
        // console.log('Fetching data for udiseNumber:', udiseNumber);
        const response = await axios.get(`${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/root/${finYear}.json`);
        const fetchedData = response.data;

        console.log("fetchedData", fetchedData);

        if (fetchedData) {
          setRootData(fetchedData);
        } else {
          setRootData({});
        }
      } catch (error) {
        console.error('Error fetching root data:', error);
      }
    };

    if (isDefaultYearLoaded) {
      fetchRootData();
    }
  }, [udiseNumber, finYear, isDefaultYearLoaded]);

  const [initialLoad, setInitialLoad] = useState(true);

  useEffect(() => {
    // Set initial load to false to avoid unnecessary updates
    if (initialLoad) {
      setInitialLoad(false);
      return;
    }

    if (rootData && filteredStudents.length > 0) {
      // Update students based on rootData changes
      const updatedStudents = filteredStudents.map((student) => {
        // Find the root that matches the student's serial number
        const assignedRoot = Object.values(rootData).find(root =>
          root.studentSerialNo?.[student.serialNo]
        );

        // Return updated student with root display
        return {
          ...student,
          rootDisplay: assignedRoot ? `${assignedRoot.fromtheway} - ${assignedRoot.thewayup}` : '',
        };
      });

      // Check if there's an actual change before updating state
      const hasChanges = updatedStudents.some((student, index) =>
        student.rootDisplay !== filteredStudents[index]?.rootDisplay
      );

      if (hasChanges) {
        setFilteredStudents(updatedStudents);
      }
    }
  }, [rootData, filteredStudents, initialLoad]);


  const handleEdit = (index) => {
    const student = tableData[index];
    setFeetype(student.feetype || '');
    setAmount(student.amount || '');
    setClassType(student.classType || '');
    setSchoolBus(student.schoolBus || false);
    setEditIndex(index);
  };

  const handleUpdate = async (e) => {
    e.preventDefault();

    const oldFeetype = tableData[editIndex].feetype; // e.g., "r6-1st"
    const baseFeetype = oldFeetype.split('-')[0]; // e.g., "r6"
    const oldClassType = oldFeetype.split('-')[1]; // e.g., "1st"

    const newClassType = schoolBus ? 'All' : classType; // e.g., "3rd"

    let newFeetype;
    // console.log("feetype",feetype);

    // If the user selects "All" as the class type, store feetype without appending class type
    if (newClassType === 'All') {
      newFeetype = baseFeetype; // Store feetype directly without class type
    } else {
      // If feetype input is unchanged or empty, use baseFeetype with newClassType
      if (!feetype || feetype === oldFeetype || feetype === baseFeetype) {
        newFeetype = `${baseFeetype}-${newClassType.replace(/\./g, '_')}`; // e.g., "r6-3rd"
      } else {
        // If feetype is explicitly changed by the user, use the new feetype value
        newFeetype = `${feetype}-${newClassType.replace(/\./g, '_')}`; // Append new class type
      }
    }



    const updatedStudent = {
      feetype: newFeetype,
      amount: amount,
      classType: newClassType,
      schoolBus,
    };

    try {
      const deleteUrl = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/fees/${finYear}/${oldFeetype}.json`;
      const deleteResponse = await fetch(deleteUrl, { method: 'DELETE' });

      // console.log("Delete response:", deleteResponse);

      if (deleteResponse.ok) {
        const addUrl = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/fees/${finYear}/${newFeetype}.json`;
        const addResponse = await fetch(addUrl, {
          method: 'PUT',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(updatedStudent),
        });

        // console.log("Add response:", addResponse);

        if (addResponse.ok) {
          const updatedTableData = tableData.filter((row) => row.feetype !== oldFeetype);
          updatedTableData.push(updatedStudent);
          setTableData(updatedTableData);
          clearForm();
          setEditIndex(null);
          setAlertMessage('Data updated successfully!');
        } else {
          throw new Error('Failed to add new fee type.');
        }
      } else {
        throw new Error('Failed to delete old fee type.');
      }
    } catch (error) {
      console.error('Error updating data in Firebase:', error);
      setAlertMessage('Failed to update data. Please try again.');
    }
  };

  const handleDelete = async (index) => {
    const itemToDelete = tableData[index];
    if (!itemToDelete) {
      setAlertMessage('Item not found.');
      return;
    }

    const databaseURL = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/fees/${finYear}/${itemToDelete.feetype}.json`;

    try {
      const response = await fetch(databaseURL, { method: 'DELETE' });

      if (response.ok) {
        setAlertMessage('Data deleted successfully!');
        const updatedTableData = tableData.filter((_, i) => i !== index);
        setTableData(updatedTableData);
      } else {
        throw new Error('Failed to delete data.');
      }
    } catch (error) {
      console.error('Error deleting data from Firebase:', error);
      setAlertMessage('Failed to delete data. Please try again.');
    }
  };

  const clearForm = () => {
    setFeetype('');
    setAmount('');
    setClassType('');
    setSchoolBus(false);
    setFromtheway('');
    setThewayup('');
  };

  const closeButtonStyle = {
    position: 'absolute', top: '5px', right: '10px', backgroundColor: isHovered ? 'darkred' : 'red',
    color: 'black', border: 'none', fontSize: '30px', cursor: 'pointer', padding: '0px', margin: '0px', height: '40px', width: '40px', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', transition: 'all 0.3s ease',
  };


  const fetchDataroot = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/root/${finYear}.json`);
      const fetchedData = response.data;
      if (fetchedData) {
        const dataArray = Object.keys(fetchedData).map((key) => ({
          id: key,
          ...fetchedData[key],
        }));
        console.log("dataArray", dataArray);

        setData(dataArray);
      } else {
        setData([]);
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  useEffect(() => {
    if (isDefaultYearLoaded) {
      fetchDataroot();
    }
  }, [udiseNumber, finYear, isDefaultYearLoaded]);

  const getNextRootKey = () => {
    if (data.length === 0) {
      return 'root1';
    }
    const rootKeys = data.map((item) => parseInt(item.id.replace('root', ''), 10));
    const maxKey = Math.max(...rootKeys);
    return `root${maxKey + 1}`;
  };

  const handleRootAssign2 = async (e) => {
    e.preventDefault();

    const newData = {
      fromtheway,
      thewayup,
      amount1,
    };
    try {
      if (editMode && editId) {
        await axios.put(`${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/root/${finYear}/${editId}.json`, newData);
        const updatedData = data.map((item) => (item.id === editId ? { id: editId, ...newData } : item));
        console.log("root updatedData", updatedData);

        setData(updatedData);
      } else {
        const rootKey = getNextRootKey();
        await axios.put(`${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/root/${finYear}/${rootKey}.json`, newData);
        setData([...data, { id: rootKey, ...newData }]);
        const newRoot = { id: rootKey, ...newData }; // Create a new root object

        setRoots((prevRoots) => [...prevRoots, newRoot]);
      }

      // Clear form fields and states
      setFromtheway('');
      setThewayup('');
      setAmount1('');

      setShowNewAddForm(true);
      setEditId(null);
    } catch (error) {
      console.error('Error saving data:', error);
    }
  };

  const handleDelete1 = async (key) => {
    try {
      const databaseURL = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/root/${finYear}/${key}.json`;
      const response = await axios.delete(databaseURL);
      if (response.status === 200) {
        const updatedData = data.filter((item) => item.id !== key);
        // console.log("root updatedData2",updatedData);

        setData(updatedData);
      } else {
        throw new Error('Failed to delete data.');
      }
    } catch (error) {
      console.error('Error deleting data:', error);
    }
  };

  const handleEdit1 = (index) => {
    const itemToEdit = data[index];
    setFromtheway(itemToEdit.fromtheway);
    setThewayup(itemToEdit.thewayup);
    setAmount1(itemToEdit.amount1);
    setEditMode(true);
    setEditId(itemToEdit.id);
    setShowNewAddForm(true);
  };

  const fetchDataroot1 = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/root/${finYear}.json`);
      const fetchedData = response.data;

      if (fetchedData) {
        // Convert the object to an array of objects
        const dataArray = Object.keys(fetchedData).map((key) => ({
          id: key,
          fromtheway: fetchedData[key].fromtheway,
          thewayup: fetchedData[key].thewayup,
        }));

        // Update the state with the fetched data
        setRoots(dataArray);
      } else {
        setRoots([]); // Clear data if no data found
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  useEffect(() => {
    if (isDefaultYearLoaded) {
      fetchDataroot1();
    }
  }, [udiseNumber, finYear, isDefaultYearLoaded]);



  // **********************************************************************************************************************************

  const [updatebeforePay, setupdateBeforePay] = useState(0);

  useEffect(() => {
    if (selectedStudentSerialNo && udiseNumber && isDefaultYearLoaded) {
      fetchFeeDetails(selectedStudentSerialNo);
    }
  }, [selectedStudentSerialNo, selectedClass, year, udiseNumber, isDefaultYearLoaded]);

  const handleInputChange = (e, rowIndex, colName) => {
    const newData = [...tableData];
    const rawValue = e.target.value;
    const value = parseFloat(rawValue) || 0; // Convert input to a float or default to 0

    if (value < 0) {
      setAlertMessage("Negative values are not allowed.");
      newData[rowIndex] = {
        ...newData[rowIndex],
        [colName]: '', // Reset the value to  0 or handle as needed
      };
      setTableData(newData);
      return;
    }
    const currentRow = newData[rowIndex];
    const amount = parseFloat(currentRow.amount) || 0;
    const beforePay = parseFloat(currentRow.beforePay) || 0;

    // Prevent input if beforePay is greater than or equal to amount
    if (beforePay + value > amount) {

      newData[rowIndex] = {
        ...newData[rowIndex],
        [colName]: '', // Reset the value to  0 or handle as needed
      };
      setTableData(newData);
      return; // Exit the function to prevent further changes
    }

    const remainingAmount = parseFloat(currentRow.remainingAmount) || 0;


    let isError = false;

    if (colName === 'payAmount') {
      // Prevent input if amount and beforePay are equal (already handled above)
      if (amount === beforePay) {
        newData[rowIndex] = {
          ...newData[rowIndex],
          payAmount: '', // Reset payAmount to 0 or handle as needed
          isPayAmountError: true, // Set error flag for styling
        };
        return; // Exit function to prevent further changes
      }

      // Check if payAmount is greater than amount if remainingFee is 0
      if (remainingAmount === 0 && value > amount) {
        isError = true;
      }
      // Check if payAmount is greater than remaining fee minus before pay if remainingFee is not 0
      else if (remainingAmount !== 0 && value > remainingAmount - beforePay) {
        isError = true;
      }

      if (isError) {
        // Set error flag and do not include this value in the total
        newData[rowIndex] = {
          ...newData[rowIndex],
          payAmount: '', // Reset payAmount to 0 so it doesn't contribute to the total
          isPayAmountError: true, // Set error flag for styling
        };
      } else {
        newData[rowIndex] = {
          ...newData[rowIndex],
          payAmount: rawValue,
          isPayAmountError: false, // Clear error flag
        };
      }
    }
    // Handle discountPercent logic
    else if (colName === 'discountPercent') {
      const discountAmount = (amount * value) / 100;
      const remainingAmount = amount - discountAmount;
      newData[rowIndex] = {
        ...newData[rowIndex],
        [colName]: value,
        discountAmount: discountAmount.toFixed(2),
        remainingAmount: remainingAmount.toFixed(2),
      };
    }
    // Handle discountAmount logic
    else if (colName === 'discountAmount') {
      const discountPercent = (value / amount) * 100;
      const remainingAmount = amount - value;
      newData[rowIndex] = {
        ...newData[rowIndex],
        [colName]: value,
        discountPercent: discountPercent.toFixed(2),
        remainingAmount: remainingAmount.toFixed(2),
      };
    }
    // Handle other cases
    else {
      newData[rowIndex][colName] = rawValue;
    }

    // console.log("updated row data", newData[rowIndex]);
    // console.log("updated tableData", newData);
    const filteredData = newData.filter(row => {
      const amount = parseFloat(row.amount);
      return !isNaN(amount) && amount > 0;
    });

    // console.log("filtered tableData", filteredData);

    // Update tableData with filtered data
    setTableData(filteredData);

    // Update typedPayAmount and typedBeforepay state objects
    const feeTypeUpdateReport = newData[rowIndex].feetype;
    setTypedPayAmount((prevTypedPayAmount) => ({
      ...prevTypedPayAmount,
      [feeTypeUpdateReport]: rawValue,
    }));
    setTypedBeforepay((prevTypedBeforepay) => ({
      ...prevTypedBeforepay,
      [feeTypeUpdateReport]: beforePay,
    }));
  };
  const [hasPressedEnter, setHasPressedEnter] = useState(false); // New state variable



  const saveToFirebase = async (udiseNumber, serialNo, invoiceNo, feetype, data, lastjamaNo, lastnaveNo) => {
    // console.log("invoiceNo pressed saveToFirebase",invoiceNo);
    console.log("lastjamaNo", lastjamaNo);
    console.log("lastnaveNo", lastnaveNo);



    if (hasPressedEnter) {
      // console.log("cannot press enter key here");
      return;
    }

    try {
      const feesUrl = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/studentFee/${year}/${serialNo}/${invoiceNo}/${feetype}.json`;
      const dataWithInvoice = { ...data, invoiceNo, transaction: transactionValue };

      if (typeofattach === "singlePavati") {


        if (selecteddebitKhate === "" && selectedcreditKhate) {

          if (lastjamaNo !== null && lastjamaNo !== undefined) {
            dataWithInvoice.jamapavatino = lastjamaNo + 1;
            dataWithInvoice.navepavatino = '';
          }
        } else if (selectedcreditKhate === "" && selecteddebitKhate) {

          if (lastnaveNo !== null && lastnaveNo !== undefined) {
            dataWithInvoice.navepavatino = lastnaveNo + 1;
            dataWithInvoice.jamapavatino = '';
          }
        }
        else {

          if (lastjamaNo !== null && lastjamaNo !== undefined) {
            dataWithInvoice.jamapavatino = lastjamaNo + 1;
          }
          if (lastnaveNo !== null && lastnaveNo !== undefined) {
            dataWithInvoice.navepavatino = lastnaveNo + 1;
          }
        }
      }
      if (data.amount > 0) {
        var response = await fetch(feesUrl, {
          method: 'PUT',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(dataWithInvoice),
        })
      };

      if (!response.ok) {
        throw new Error('Failed to save data to Firebase');
      }

      // Check if the invoice number is new by comparing it with the last invoice number in Firebase
      const lastInvoiceUrl = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/studentFee/${year}/lastInvoiceNo.json`;
      const lastInvoiceResponse = await fetch(lastInvoiceUrl);

      if (!lastInvoiceResponse.ok) {
        throw new Error('Failed to fetch last invoice number from Firebase');
      }

      const lastInvoiceNo = await lastInvoiceResponse.json();

      // Only update the lastInvoiceNo if the current invoice number is greater than the last invoice number
      if (invoiceNo > lastInvoiceNo) {
        const updateLastInvoiceResponse = await fetch(lastInvoiceUrl, {
          method: 'PUT',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(invoiceNo), // Save the current invoice number
        });

        if (!updateLastInvoiceResponse.ok) {
          throw new Error('Failed to save last invoice number to Firebase');
        }

        // console.log('New last invoice number saved successfully!');
      } else {
        // console.log('Existing invoice. Not updating last invoice number.');
      }

      // console.log('Data saved successfully!');
    } catch (error) {
      console.error('Error saving data to Firebase:', error);
    }
  };

  useEffect(() => {
    fetchLastInvoiceNo();
  }, [year, udiseNumber]);

  const fetchLastInvoiceNo = async () => {
    try {
      const lastInvoiceUrl = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/studentFee/${year}/lastInvoiceNo.json`;
      const response = await fetch(lastInvoiceUrl);

      if (!response.ok) {
        throw new Error('Failed to fetch last invoice number from Firebase');
      }
      const lastInvoiceNo = await response.json();
      const newInvoiceNo = lastInvoiceNo === null ? 1 : parseInt(lastInvoiceNo) + 1;

      // Update the state with the fetched and incremented invoice number
      setInvoiceNo(newInvoiceNo);
      setmylastInvoiceNo(newInvoiceNo);
    } catch (error) {
      console.error('Error fetching last invoice number:', error);
    }
  };

  const handleFeeTypeSubmit = async (e) => {
    e.preventDefault();
    if (hasPressedEnter) {
      return;
    }
    if (!selectedStudentSerialNo) {
      setAlertMessage('Please select a student before saving fee details.');
      return;
    }

    const hasValidPayAmount = tableData.some(row => parseFloat(row.payAmount) > 0);
    if (!hasValidPayAmount) {
      setAlertMessage('Please enter a valid amount in the Paid Fee column before saving.');
      return;
    }
    setLoading(true);
    setisloading(true)

    const currentInvoiceNo = invoiceNo; // This is either the existing or new invoice number
    const currentDate = new Date().toISOString().split('T')[0]; // Adjust date format as needed

    try {
      const fetchLastNaveAndJamaNo = async () => {
        const lastNaveNoUrl = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/account/kird/${selectedKirdType}/${year}/lastnaveNo.json`;
        const lastJamaNoUrl = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/account/kird/${selectedKirdType}/${year}/lastjamaNo.json`;

        let lastnaveNo = 0;
        let lastjamaNo = 0;

        try {
          const [naveResponse, jamaResponse] = await Promise.all([
            fetch(lastNaveNoUrl),
            fetch(lastJamaNoUrl)
          ]);
          if (naveResponse.ok) {
            const naveData = await naveResponse.json();
            if (naveData !== null) {
              lastnaveNo = naveData.lastnaveNo || 0;
            }
          }

          if (jamaResponse.ok) {
            const jamaData = await jamaResponse.json();
            if (jamaData !== null) {
              lastjamaNo = jamaData.lastjamaNo || 0;
            }
          }

        } catch (error) {
          console.error('Error fetching last naveNo or jamaNo:', error);
        }

        return { lastnaveNo, lastjamaNo };
      };


      let lastnaveNo = 0;
      let lastjamaNo = 0;
      let accountEntriesCreated = false;
      if (typeofattach === "singlePavati" && !accountEntriesCreated) {
        const { lastnaveNo: fetchedLastNaveNo, lastjamaNo: fetchedLastJamaNo } = await fetchLastNaveAndJamaNo();
        lastnaveNo = fetchedLastNaveNo;
        lastjamaNo = fetchedLastJamaNo;
      }






      for (const row of tableData) {
        // Add the pay amount to the before pay before saving
        const payAmount = parseFloat(row.payAmount) || 0; // Get the pay amount
        const beforePay = parseFloat(row.beforePay) || 0; // Get the current before pay
        const updatedBeforePay = (beforePay + payAmount).toFixed(2); // Update before pay

        // Prepare fee details
        const feeDetails = {
          class: selectedClass,
          amount: row.amount,
          discountPercent: row.discountPercent,
          discountAmount: row.discountAmount,
          remainingAmount: row.remainingAmount,
          beforePay: updatedBeforePay,
          // payAmount: row.payAmount,
          payAmount: 0,
          date: date,
          year: year,
          division: selectedDivision,
          division: selectedDivision,
          transaction: transactionValue,
          ...(transactionValue === "Online" && {
            paymentGatewayType,
            transactionId
          }),
          ...(transactionValue === "Check book" && {
            checkNo,
            checkDate
          }),
          ...(transactionValue === "By DD" && {
            ddNo,
            dddate
          }),
        };

        const feeDetailsWithPayAmount = tableData.map((fee) => {
          // Check if the fee type has been modified
          const payAmount = typedPayAmount[fee.feetype] || fee.payAmount || 0;
          const beforePay = typedBeforepay[fee.feetype] || fee.beforePay || 0;

          return {
            ...fee,
            payAmount: payAmount,
            beforePay: beforePay,
          };
        });

        // console.log("feeDetailsWithPayAmount",feeDetailsWithPayAmount);

        if (typeofattach === "singlePavati" && !accountEntriesCreated) {

          const { lastnaveNo, lastjamaNo } = await fetchLastNaveAndJamaNo();




          if (currentInvoiceNo === mylastInvoiceNo && !accountEntriesCreated) {
            // Save to account system (new separated logic)
            createAccountEntry(feeDetails, feeDetailsWithPayAmount, currentInvoiceNo, lastnaveNo, lastjamaNo);
            accountEntriesCreated = true;
          }

        }


        const lastjamaNo22 = (currentInvoiceNo == mylastInvoiceNo ? lastjamaNo : (feeDetailsWithPayAmount[0].jamapavatino - 1))
        const lastnaveNo22 = (currentInvoiceNo == mylastInvoiceNo ? lastnaveNo : feeDetailsWithPayAmount[0].navepavatino - 1)


        // Save fee details for the current invoice
        await saveToFirebase(udiseNumber, selectedStudentSerialNo, currentInvoiceNo, row.feetype, feeDetails, lastjamaNo22, lastnaveNo22);

        if (row.feetype.toLowerCase().includes("pending fee") && payAmount > 0) {
          try {
            const getPreviousYear = (currentYear) => {
              if (!currentYear) return "";
              const parts = currentYear.split("-");
              if (parts.length === 2) {
                const start = parseInt(parts[0], 10);
                const end = parseInt(parts[1], 10);
                if (!isNaN(start) && !isNaN(end)) {
                  return `${start - 1}-${end - 1}`;
                }
              }
              return "";
            };

            const pYear = getPreviousYear(year);
            if (pYear) {
              const prevStudentFeeUrl = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/studentFee/${pYear}/${selectedStudentSerialNo}.json`;
              const prevStudentFeeRes = await fetch(prevStudentFeeUrl);
              if (prevStudentFeeRes.ok) {
                const prevStudentFeeData = await prevStudentFeeRes.json();
                if (prevStudentFeeData && typeof prevStudentFeeData === "object") {
                  const invoiceMap = {};
                  const beforePayMap = {};
                  const amountMap = {};
                  const discountMap = {};

                  // Sort invoices numerically
                  const sortedInvoices = Object.keys(prevStudentFeeData).sort((a, b) => parseInt(a) - parseInt(b));
                  for (const invNo of sortedInvoices) {
                    const fees = prevStudentFeeData[invNo];
                    if (fees && typeof fees === "object") {
                      for (const [ft, fd] of Object.entries(fees)) {
                        if (fd) {
                          invoiceMap[ft] = invNo;
                          beforePayMap[ft] = parseFloat(fd.beforePay || 0);
                          amountMap[ft] = parseFloat(fd.amount || 0);
                          discountMap[ft] = parseFloat(fd.discountAmount || 0);
                        }
                      }
                    }
                  }

                  let remainingPayment = payAmount;
                  for (const ft in invoiceMap) {
                    if (remainingPayment <= 0) break;

                    const totalAmt = amountMap[ft];
                    const discountAmt = discountMap[ft];
                    const prevPaid = beforePayMap[ft];
                    const remainingBalance = totalAmt - discountAmt - prevPaid;

                    if (remainingBalance > 0) {
                      const allocate = Math.min(remainingPayment, remainingBalance);
                      const newBeforePay = (prevPaid + allocate).toFixed(2);

                      const updateUrl = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/studentFee/${pYear}/${selectedStudentSerialNo}/${invoiceMap[ft]}/${ft}/beforePay.json`;
                      await fetch(updateUrl, {
                        method: 'PUT',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify(newBeforePay)
                      });

                      remainingPayment -= allocate;
                    }
                  }
                }
              }
            }
          } catch (err) {
            console.error("Error distributing pending fee to previous year:", err);
          }
        }

      }




      // Check if the current invoice number is greater than the last invoice number before updating
      const lastInvoiceUrl = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/studentFee/${year}/lastInvoiceNo.json`;
      const lastInvoiceResponse = await fetch(lastInvoiceUrl);

      if (lastInvoiceResponse.ok) {
        const lastInvoiceNo = await lastInvoiceResponse.json();
        if (currentInvoiceNo > lastInvoiceNo) {
          // Only update the last invoice number if the current one is greater
          await fetch(lastInvoiceUrl, {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(currentInvoiceNo), // Save the current invoice number
          });
          // console.log('New last invoice number saved successfully!');
        } else {
          // console.log('Existing invoice. Not updating last Invoice Number.');
        }
      }

      // **Add the filtering logic here**
      const updatedFeeDetails = tableData.filter((fee) => typedPayAmount[fee.feetype] > 0);
      if (updatedFeeDetails.length > 0) {
      }


      const feeDetailsWithPayAmount = tableData.map((fee) => {
        // Check if the fee type has been modified
        const payAmount = typedPayAmount[fee.feetype] || fee.payAmount || 0;
        const beforePay = typedBeforepay[fee.feetype] || fee.beforePay || 0;

        return {
          ...fee,
          payAmount: payAmount,
          beforePay: beforePay,
        };
      });


      if (currentInvoiceNo < mylastInvoiceNo) {
        // Update the account entries
        await updateAccountEntries(feeDetailsWithPayAmount, currentInvoiceNo);
      }



      // console.log("feeDetailsWithPayAmount",feeDetailsWithPayAmount);

      const reportDataUpdated = {
        studentName: stdType,
        studentClass: selectedClass,
        studentDivision: selectedDivision,
        pavatiNo: currentInvoiceNo,
        date: currentDate,
        year: year,
        currentInvoiceNo: currentInvoiceNo,
        registerNo: selectedRegisterNo,
        feeDetails: feeDetailsWithPayAmount,
        previousBeforePay: updatebeforePay,
        transaction: transactionValue,
        ...(transactionValue === "Online" && {
          paymentGatewayType,
          transactionId
        }),
        ...(transactionValue === "Check book" && {
          checkNo,
          checkDate
        }),
        ...(transactionValue === "By DD" && {
          ddNo,
          dddate
        }),

      };

      console.log("reportDataUpdated22", reportDataUpdated);

      // Update the tableData state with the new values
      const updatedTableData = tableData.map((row, index) => {
        const payAmount = parseFloat(row.payAmount) || 0; // Get the pay amount
        const beforePay = parseFloat(row.beforePay) || 0; // Get the current before pay
        const newBeforePay = (beforePay + payAmount).toFixed(2); // Update before pay
        return { ...row, beforePay: newBeforePay, payAmount: 0 };
      });

      setTableData(updatedTableData);

      setReportDataUpdated(reportDataUpdated);
      setShowUpdatedPavatiButton(true);
      setAlertMessage('Fee details saved successfully!');

      // Clear typed fields
      setTransactionValue('By Cash');
      setPaymentGatewayType('');
      setTransactionId('');
      setCheckNo('');
      setCheckDate('');
      setddNo('');
      setdddate('');
      setisloading(false)

      fetchLastInvoiceNo();
      if (invoiceNo == mylastInvoiceNo - 1) {
        setInvoiceNo(mylastInvoiceNo - 1);
      } else {
        setInvoiceNo(mylastInvoiceNo + 1);
      }
    } catch (error) {
      console.error('Error saving fee details:', error);
      setAlertMessage('An error occurred while saving fee details. Please try again.');
    } finally {
      // Reset loading state after the operation is complete
      setLoading(false);
    }
  };


  const updateAccountEntries = async (feeDetailsWithPayAmount, currentInvoiceNo) => {
    try {
      console.log("updateAccountEntries called");

      // Calculate the total payAmount from feeDetailsWithPayAmount
      const totalPayAmount = feeDetailsWithPayAmount.reduce((total, fee) => {
        return total + (parseFloat(fee.payAmount) || 0); // Ensure to parse the payAmount as a float
      }, 0);

      const jamapavatiNo = feeDetailsWithPayAmount[0].jamapavatino;
      const navepavatiNo = feeDetailsWithPayAmount[0].navepavatino;

      // Prepare the transaction data for account updates
      const transactionData = {
        Amount: totalPayAmount, // Use the calculated total pay amount
        Remark: `Amount transferred from Students fee. Invoice No: ${currentInvoiceNo}`,
        date: feeDetailsWithPayAmount[0].date,
        financialYear: year,
        khatePrakar: feeDetailsWithPayAmount[0].transaction,
        currenttime: new Date().toLocaleTimeString('en-GB', {
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit',
          hour12: false
        }),
      };

      // Update jama node if exists
      if (jamapavatiNo) {
        const jamaUrl = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/account/kird/${selectedKirdType}/${year}/jama/${jamapavatiNo}.json`;
        const existingJamaResponse = await fetch(jamaUrl);
        const existingJamaData = await existingJamaResponse.json();

        // Merge existing data with new transaction data
        const updatedJamaData = {
          ...existingJamaData, // Retain existing data
          ...transactionData, // Update with new transaction data
        };

        await fetch(jamaUrl, {
          method: 'PUT',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(updatedJamaData)
        });
      }

      // Update nave node if exists
      if (navepavatiNo) {
        const naveUrl = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/account/kird/${selectedKirdType}/${year}/nave/${navepavatiNo}.json`;
        const existingNaveResponse = await fetch(naveUrl);
        const existingNaveData = await existingNaveResponse.json();

        // Merge existing data with new transaction data
        const updatedNaveData = {
          ...existingNaveData, // Retain existing data
          ...transactionData, // Update with new transaction data
        };

        await fetch(naveUrl, {
          method: 'PUT',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(updatedNaveData)
        });
      }

      console.log('Account entries updated successfully');
    } catch (error) {
      console.error('Error updating account entries:', error);
    }
  };



  const fetchStudentData = async (serialNo) => {
    if (!serialNo) {
      console.error('Serial Number is undefined');
      return;
    }
    try {
      const studentUrl = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/studentData/${serialNo}.json`;
      const response = await fetch(studentUrl);
      const studentData = await response.json();

      if (studentData) {
        setStdType(studentData.stdName + " " + studentData.stdFather + " " + studentData.stdSurname);
        setSelectedClass(studentData.currentClass);
        setSelectedRegisterNo(studentData.registerNo);
        setSelectedDivision(studentData.division);

        // Fetch fee types for the selected student's class
        const feeTypesUrl = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/fees/${finYear}.json`;
        const feeTypesResponse = await fetch(feeTypesUrl);
        const feeTypesData = await feeTypesResponse.json();

        // Filter fees for the selected classType and 'All' classType
        let filteredFees = [];
        if (feeTypesData) {
          filteredFees = Object.keys(feeTypesData)
            .filter(key => feeTypesData[key].classType === studentData.currentClass || feeTypesData[key].classType === 'All')
            .map(key => ({
              ...feeTypesData[key],
              feetype: key
            }));
        }

        // Fetch pending fee for the selected student
        const pendingFeesUrl = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/pendingFee/${year}/${serialNo}.json`;
        const pendingFeesResponse = await fetch(pendingFeesUrl);
        const pendingFeeData = await pendingFeesResponse.json();

        // Fetch hostel fee for the selected student
        const hostelFeesUrl = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/hostel/${year}/${serialNo}.json`;
        console.log("hostelFeesUrl", hostelFeesUrl);

        const hostelFeesResponse = await fetch(hostelFeesUrl);
        const hostelFeeData = await hostelFeesResponse.json();

        // Fetch Id fee for the selected student
        const IdFeesUrl = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/IdFees/${year}/${serialNo}.json`;
        console.log("IdFeesUrl", IdFeesUrl);

        const IdFeesResponse = await fetch(IdFeesUrl);
        const IdFeeData = await IdFeesResponse.json();


        // Prepare the pending fee row
        let pendingFeeRow = null;
        if (pendingFeeData) {
          const pendingFeeAmount = pendingFeeData || 0;
          pendingFeeRow = {
            feetype: 'Pending Fee',
            amount: pendingFeeAmount,
            discountPercent: 0,
            discountAmount: 0,
            remainingAmount: pendingFeeAmount,
            beforePay: 0,
            payAmount: 0,
          };
        }

        // Prepare the hostel fee row
        let hostelFeeRow = null;
        console.log("hostelFeeData", hostelFeeData);

        if (hostelFeeData) {
          const hostelFeeAmount = hostelFeeData || 0;
          hostelFeeRow = {
            feetype: 'Hostel Fee',
            amount: hostelFeeAmount,
            discountPercent: 0,
            discountAmount: 0,
            remainingAmount: hostelFeeAmount,
            beforePay: 0,
            payAmount: 0,
          };
        }

        // Prepare the Id fee row
        let IdFeeRow = null;
        console.log("IdFeeData", IdFeeData);

        if (IdFeeData) {
          const IdFeeAmount = IdFeeData || 0;
          IdFeeRow = {
            feetype: 'Identity Card Fee',
            amount: IdFeeAmount,
            discountPercent: 0,
            discountAmount: 0,
            remainingAmount: IdFeeAmount,
            beforePay: 0,
            payAmount: 0,
          };
        }


        // const busFeeFromRoot = await fetchBusFeeFromRootNode(serialNo);
        // console.log('Bus fee from root:', busFeeFromRoot);




        // Combine filtered fees with pending fee and hostel fee and IdFee
        const updatedTableData = [...filteredFees];
        if (pendingFeeRow) updatedTableData.push(pendingFeeRow);
        if (hostelFeeRow) updatedTableData.push(hostelFeeRow);
        if (IdFeeRow) updatedTableData.push(IdFeeRow);


        //     console.log("busFeeFromRoot",busFeeFromRoot);

        //     if (busFeeFromRoot && busFeeFromRoot.amount1) {
        //       updatedTableData.push({
        //     feetype: 'Bus Fee',
        //     amount: busFeeFromRoot.amount1 || '', // Use amount1 from the database or default to ''
        //     fromtheway: busFeeFromRoot.fromtheway || '', // Use fromtheway from the database or default to ''
        //     thewayup: busFeeFromRoot.thewayup || '', // Use thewayup from the database or default to ''
        //     classType: busFeeFromRoot.classType || 'All', // Use classType from the database or default to 'All'
        //     schoolBus: true, // Mark as a school bus fee
        //   });
        // }

        console.log("updatedTableData", updatedTableData);


        setTableData(updatedTableData);
      } else {
        console.error('Student data not found');
      }
    } catch (error) {
      console.error('Error fetching student data:', error);
    }
  };


  const fetchFeeTypes = async (classType) => {
    try {
      const response = await fetch(`${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/fees/${finYear}.json`);
      const feesData = await response.json();

      let filteredFees = [];
      if (feesData) {
        // Filter fees for the selected classType and 'All' classType
        filteredFees = Object.keys(feesData)
          .filter(key => feesData[key].classType === classType || feesData[key].classType === 'All')
          .map(key => ({
            ...feesData[key],
            feetype: key
          }));
      }

      const pendingFeeRow = {
        feetype: 'Pending Fee',
        amount: 0, // Set the default amount for Pending Fee
        discountPercent: 0,
        discountAmount: 0,
        remainingAmount: 0,
        beforePay: 0,
        payAmount: 0,
        classType: classType // Ensure it has the correct class type
      };

      return [...filteredFees, pendingFeeRow];

    } catch (error) {
      console.error('Error fetching fee types:', error);
      return [];
    }
  };


  const fetchFeeDetails = async (serialNo) => {
    try {
      const feeUrl = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/studentFee/${year}/${serialNo}.json`;
      const response = await fetch(feeUrl);
      const feeData = await response.json();
      console.log("feeData", feeData);
      console.log("feeUrl", feeUrl);

      if (!feeData) {
        console.log('No fee data found for the selected student, falling back to default class fees.');
      }

      // Find the latest transaction based on date (not invoice number)
      let latestFeeData = null;
      let latestDate = null;
      let latestBeforePay = 0;

      if (feeData) {

      Object.keys(feeData).forEach(invoiceNo => {
        const currentFeeData = feeData[invoiceNo];
        if (!currentFeeData || typeof currentFeeData !== 'object') return;

        // Get the date from any fee type in this invoice (they all have the same date)
        const feeTypes = Object.keys(currentFeeData);
        if (feeTypes.length > 0) {
          const currentDate = new Date(currentFeeData[feeTypes[0]].date);
          const currentBeforePay = parseFloat(currentFeeData[feeTypes[0]].beforePay || 0);

          if (!latestDate || currentDate > latestDate) {
            // This transaction is more recent
            latestDate = currentDate;
            latestFeeData = currentFeeData;
            latestBeforePay = currentBeforePay;
          } else if (currentDate.getTime() === latestDate.getTime()) {
            // Same date, use beforePay as tie-breaker (higher beforePay = more recent)
            if (currentBeforePay > latestBeforePay) {
              latestFeeData = currentFeeData;
              latestBeforePay = currentBeforePay;
            }
          }
        }
      });
      }

      // Convert the latest fee data into a format suitable for the table
      const classFeeTypes = await fetchFeeTypes(selectedClass);  // selectedClass should already be in state
      console.log("All class feeTypes", classFeeTypes);

      // Convert latest invoice data (if exists) to map
      const latestFeeDataMap = latestFeeData ? latestFeeData : {};
      console.log("Latest Paid Data", latestFeeDataMap);

      // Merge: For each class-wise feetype, merge with paid data if available
      const formattedFeeData = classFeeTypes.map(fee => {
        const paidData = latestFeeDataMap[fee.feetype] || {};
        return {
          feetype: fee.feetype,
          amount: fee.amount,
          discountPercent: paidData.discountPercent || 0,
          discountAmount: paidData.discountAmount || 0,
          remainingAmount: paidData.remainingAmount || fee.amount,
          beforePay: paidData.beforePay || 0,
          payAmount: paidData.payAmount || 0,
          classType: fee.classType || 'All',
        };
      });

      // Fetch pending fee and student profile for the selected student
      const pendingFeesUrl = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/pendingFee/${year}/${serialNo}.json`;
      const studentProfileUrl = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/studentData/${serialNo}.json`;

      const [pendingFeesResponse, studentProfileResponse] = await Promise.all([
        fetch(pendingFeesUrl),
        fetch(studentProfileUrl)
      ]);
      const pendingFeeData = await pendingFeesResponse.json();
      const studentProfile = studentProfileResponse.ok ? await studentProfileResponse.json() : null;

      let pendingFeeAmount = parseFloat(pendingFeeData) || 0;
      let isFreshStudent = false;

      // Helper function to get previous year
      const getPreviousYear = (currentYear) => {
        if (!currentYear) return "";
        const parts = currentYear.split("-");
        if (parts.length === 2) {
          const start = parseInt(parts[0], 10);
          const end = parseInt(parts[1], 10);
          if (!isNaN(start) && !isNaN(end)) {
            return `${start - 1}-${end - 1}`;
          }
        }
        return "";
      };

      const pYear = getPreviousYear(year);

      if (studentProfile && studentProfile.dateOfAdmission) {
        const getAcademicYearFromDate = (dateStr) => {
          if (!dateStr) return "";
          const date = new Date(dateStr);
          if (isNaN(date.getTime())) return "";
          const yearVal = date.getFullYear();
          const monthVal = date.getMonth(); // 0-indexed
          if (monthVal >= 3) {
            return `${yearVal}-${yearVal + 1}`;
          } else {
            return `${yearVal - 1}-${yearVal}`;
          }
        };
        const admissionYear = getAcademicYearFromDate(studentProfile.dateOfAdmission);
        if (admissionYear && pYear) {
          const pStartYear = parseInt(pYear.split('-')[0], 10);
          const admStartYear = parseInt(admissionYear.split('-')[0], 10);
          if (!isNaN(pStartYear) && !isNaN(admStartYear) && pStartYear < admStartYear) {
            isFreshStudent = true;
          }
        }
      }

      if (!isFreshStudent && pendingFeeAmount === 0 && pYear && serialNo) {
        try {
          const prevStudentFeeUrl = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/studentFee/${pYear}/${serialNo}.json`;
          const prevFeesConfigUrl = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/fees/${pYear}.json`;
          const prevIdFeesUrl = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/IdFees/${pYear}/${serialNo}.json`;
          const prevHostelFeesUrl = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/hostel/${pYear}/${serialNo}.json`;
          const prevPendingFeesUrl = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/pendingFee/${pYear}/${serialNo}.json`;

          const [prevStudentFeeRes, prevFeesConfigRes, prevIdFeesRes, prevHostelFeesRes, prevPendingFeesRes] = await Promise.all([
            fetch(prevStudentFeeUrl),
            fetch(prevFeesConfigUrl),
            fetch(prevIdFeesUrl),
            fetch(prevHostelFeesUrl),
            fetch(prevPendingFeesUrl)
          ]);

          const prevStudentFeeData = prevStudentFeeRes.ok ? await prevStudentFeeRes.json() : null;
          const prevFeesConfigData = prevFeesConfigRes.ok ? await prevFeesConfigRes.json() : null;
          const prevIdFeeAmt = prevIdFeesRes.ok ? parseFloat(await prevIdFeesRes.json()) || 0 : 0;
          const prevHostelFeeAmt = prevHostelFeesRes.ok ? parseFloat(await prevHostelFeesRes.json()) || 0 : 0;
          const prevPendingFeeAmt = prevPendingFeesRes.ok ? parseFloat(await prevPendingFeesRes.json()) || 0 : 0;

          let prevTotalFee = 0;
          let prevTotalDiscount = 0;
          let prevTotalPaid = 0;

          const prevGrouped = {};
          const prevLastDiscountAmounts = {};
          const prevLastBeforePay = {};

          let prevYearClass = selectedClass;
          if (prevStudentFeeData && typeof prevStudentFeeData === "object") {
            for (const [invoiceNumber, fees] of Object.entries(prevStudentFeeData)) {
              if (fees && typeof fees === "object") {
                for (const [feetype, feeDetails] of Object.entries(fees)) {
                  if (feeDetails && feeDetails.class) {
                    prevYearClass = feeDetails.class;
                    break;
                  }
                }
              }
              if (prevYearClass !== selectedClass) break;
            }
          }

          const isFeeTypeValid = (feetype, feesConfigData, prevYearClass) => {
            const lowerFee = feetype.toLowerCase();
            if (
              lowerFee.includes("identity card fee") ||
              lowerFee.includes("hostel fee") ||
              lowerFee.includes("pending fee") ||
              lowerFee.includes("bus fee")
            ) {
              return true;
            }

            if (feesConfigData && typeof feesConfigData === "object") {
              for (const [configFeeType, feeDetails] of Object.entries(feesConfigData)) {
                if (
                  configFeeType.toLowerCase() === feetype.toLowerCase() &&
                  feeDetails &&
                  (feeDetails.classType === prevYearClass || feeDetails.classType === "All")
                ) {
                  return true;
                }
              }
              return false;
            }
            return true;
          };

          if (prevStudentFeeData && typeof prevStudentFeeData === "object") {
            for (const [invoiceNumber, fees] of Object.entries(prevStudentFeeData)) {
              if (fees && typeof fees === "object") {
                for (const [feetype, feeDetails] of Object.entries(fees)) {
                  if (feeDetails && isFeeTypeValid(feetype, prevFeesConfigData, prevYearClass)) {
                    const amount = parseFloat(feeDetails.amount || 0);
                    const discount = parseFloat(feeDetails.discountAmount || 0);
                    const beforePay = parseFloat(feeDetails.beforePay || 0);

                    prevGrouped[feetype] = amount;
                    prevLastDiscountAmounts[feetype] = discount;
                    prevLastBeforePay[feetype] = beforePay;
                  }
                }
              }
            }
          }

          for (const feetype in prevGrouped) {
            prevTotalFee += prevGrouped[feetype];
            prevTotalDiscount += prevLastDiscountAmounts[feetype] || 0;
            prevTotalPaid += prevLastBeforePay[feetype] || 0;
          }

          if (prevFeesConfigData && typeof prevFeesConfigData === "object") {
            for (const [feeType, feeDetails] of Object.entries(prevFeesConfigData)) {
              if (feeDetails && (feeDetails.classType === prevYearClass || feeDetails.classType === "All")) {
                if (prevGrouped[feeType] === undefined) {
                  const amount = parseFloat(feeDetails.amount || 0);
                  prevTotalFee += amount;
                }
              }
            }
          }

          const feeExistsInPrevGrouped = (feeName) => {
            return Object.keys(prevGrouped).some(ft => ft.toLowerCase().includes(feeName.toLowerCase()));
          };

          if (prevIdFeeAmt > 0 && !feeExistsInPrevGrouped("Identity Card Fee")) {
            prevTotalFee += prevIdFeeAmt;
          }
          if (prevHostelFeeAmt > 0 && !feeExistsInPrevGrouped("Hostel Fee")) {
            prevTotalFee += prevHostelFeeAmt;
          }
          if (prevPendingFeeAmt > 0 && !feeExistsInPrevGrouped("Pending Fee")) {
            prevTotalFee += prevPendingFeeAmt;
          }

          const remaining = prevTotalFee - prevTotalDiscount - prevTotalPaid;
          pendingFeeAmount = remaining > 0 ? remaining : 0;
        } catch (error) {
          console.error("Error calculating previous year remaining fee in Stdfee:", error);
        }
      }

      // Prepare the pending fee row
      let pendingFeeRow = null;
      if (pendingFeeAmount > 0) {
        // Set beforePay for Pending Fee based on the latest fee data
        const latestPendingFeeBeforePay = latestFeeDataMap['Pending Fee'] ? latestFeeDataMap['Pending Fee'].beforePay : 0;

        pendingFeeRow = {
          feetype: 'Pending Fee',
          amount: pendingFeeAmount,
          discountPercent: latestFeeDataMap['Pending Fee'] ? latestFeeDataMap['Pending Fee'].discountPercent : 0,
          discountAmount: latestFeeDataMap['Pending Fee'] ? latestFeeDataMap['Pending Fee'].discountAmount : 0,
          remainingAmount: pendingFeeAmount,
          beforePay: latestPendingFeeBeforePay || 0, // Set this to the latest beforePay value
          payAmount: 0,
        };
      }

      // Fetch hostel fee for the selected student
      const hostelFeesUrl = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/hostel/${year}/${serialNo}.json`;
      const hostelFeesResponse = await fetch(hostelFeesUrl);
      const hostelFeeData = await hostelFeesResponse.json();

      // Prepare the hostel fee row
      let hostelFeeRow = null;
      if (hostelFeeData) {
        const hostelFeeAmount = hostelFeeData || 0;

        hostelFeeRow = {
          feetype: 'Hostel Fee',
          amount: hostelFeeAmount,
          discountPercent: 0,
          discountAmount: 0,
          remainingAmount: hostelFeeAmount,
          beforePay: 0,
          payAmount: 0,
        };
      }

      // Fetch Id fee for the selected student
      const IdFeesUrl = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/IdFees/${year}/${serialNo}.json`;
      const IdFeesResponse = await fetch(IdFeesUrl);
      const IdFeeData = await IdFeesResponse.json();

      // Prepare the Id fee row
      let IdFeeRow = null;
      if (IdFeeData) {
        const IdFeeAmount = IdFeeData || 0;
        IdFeeRow = {
          feetype: 'Identity Card Fee',
          amount: IdFeeAmount,
          discountPercent: 0,
          discountAmount: 0,
          remainingAmount: IdFeeAmount,
          beforePay: 0,
          payAmount: 0,
        };
      }

      // Combine formatted fee data with pending fee row and hostel fee row if they don't exist
      const combinedFeeData = [
        ...formattedFeeData,
        ...(pendingFeeRow ? [pendingFeeRow] : []), // Only add if pendingFeeRow exists
        ...(hostelFeeRow ? [hostelFeeRow] : []),
        ...(IdFeeRow ? [IdFeeRow] : [])
      ].filter(Boolean); // Filter out any null or undefined values

      // Remove duplicates and keep the one with a non-null amount
      const uniqueFeeData = combinedFeeData.reduce((acc, current) => {
        const existing = acc.find(item => item.feetype === current.feetype);
        if (!existing) {
          // If it doesn't exist, add it
          acc.push(current);
        } else {
          // If it exists, check which one has a non-null amount
          if (current.amount !== null && current.amount !== undefined && current.amount !== 0) {
            // Replace with the current one if it has a valid amount
            Object.assign(existing, current);
          }
        }
        return acc;
      }, []);

      // Check if bus fee should be included or updated
      const busFeeFromRoot = await fetchBusFeeFromRootNode(serialNo);
      console.log('Bus fee from root:', busFeeFromRoot);

      if (busFeeFromRoot && busFeeFromRoot.amount1) {
        uniqueFeeData.push({
          feetype: 'Bus Fee',
          amount: busFeeFromRoot.amount1 || '', // Use amount1 from the database or default to ''
          fromtheway: busFeeFromRoot.fromtheway || '', // Use fromtheway from the database or default to ''
          thewayup: busFeeFromRoot.thewayup || '', // Use thewayup from the database or default to ''
          classType: busFeeFromRoot.classType || 'All', // Use classType from the database or default to 'All'
          schoolBus: true, // Mark as a school bus fee
        });
      }

      console.log("uniqueFeeData", uniqueFeeData);
      setTableData(uniqueFeeData); // Set the combined data to tableData
    } catch (error) {
      console.error('Error fetching fee details:', error);
    }
  };













  const fetchPendingFees = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/pendingFee.json`);
      const pendingFeesData = await response.json();
      return pendingFeesData || {};
    } catch (error) {
      console.error('Error fetching pending fees:', error);
      return {};
    }
  };

  const handleStudentClick1 = async (stdName, stdFather, stdSurname, division, currentClass, registerNo, serialNo) => {
    try {
      // console.log('Clicked student details:', stdName, division, currentClass, registerNo, serialNo);

      // Set selected student for highlighting
      setSelectedStudentSerialforcolor(serialNo);

      // Construct full name
      const fullname = `${stdName} ${stdFather} ${stdSurname}`;
      // console.log("fullname", fullname);

      // Update state with selected student details
      setStdType(fullname);
      setSelectedClass(String(currentClass));
      setSelectedRegisterNo(registerNo);
      setSelectedStudentSerialNo(serialNo);
      setSelectedDivision(division);
      setTableData([]); // Clear previous table data

      setReportDataUpdated({}); // Clear previous report data
      setShowUpdatedPavatiButton(false);
    } catch (error) {
      console.error('Error handling student click:', error); // Log any errors
    }
  };


  const fetchFeeDetailsByInvoiceNumber = async (myinvoiceNumber) => {
    try {
      const studentFeeUrl = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/studentFee/${year}.json`;
      const response = await fetch(studentFeeUrl);
      const studentFees = await response.json();
      if (!studentFees) {
        console.error('No student fee data found');
        return;
      }
      console.log("Student Fees Data:", studentFees);

      let foundInvoice = false;

      for (const studentSerialNo in studentFees) {
        for (const invoiceNo in studentFees[studentSerialNo]) {
          if (invoiceNo === myinvoiceNumber) {
            foundInvoice = true;
            const studentFeeData = studentFees[studentSerialNo][invoiceNo];
            // Log fee data for debugging
            console.log("Matching Invoice Data:", studentFeeData);

            // Get previous invoice number
            const previousInvoiceNo = Object.keys(studentFees[studentSerialNo])
              .filter((inv) => Number(inv) < Number(myinvoiceNumber))
              .sort((a, b) => b - a)[0];

            // console.log("Previous Invoice No:", previousInvoiceNo);

            const formattedFeeData = Object.keys(studentFeeData).map((feetype) => {
              // Set transaction type and related fields
              setTransactionValue(studentFeeData[feetype].transaction || "By Cash");
              setPaymentGatewayType(studentFeeData[feetype].paymentGatewayType || '');
              setTransactionId(studentFeeData[feetype].transactionId || '');
              setCheckNo(studentFeeData[feetype].checkNo || '');
              setCheckDate(studentFeeData[feetype].checkDate || '');
              setddNo(studentFeeData[feetype].ddNo || '');
              setdddate(studentFeeData[feetype].dddate || '');


              const currentBeforePay = parseFloat(studentFeeData[feetype]?.beforePay) || 0;
              const previousBeforePay =
                previousInvoiceNo &&
                parseFloat(studentFees[studentSerialNo][previousInvoiceNo]?.[feetype]?.beforePay) || 0;

              const payAmount = currentBeforePay - previousBeforePay;

              console.log(`Fee Type: ${feetype}, Current: ${currentBeforePay}, Previous: ${previousBeforePay}, PayAmount: ${payAmount}`);

              return {
                feetype,
                ...studentFeeData[feetype],
                date: studentFeeData[feetype]?.date || "N/A",
                beforePay: previousBeforePay,
                payAmount,
              };
            });

            const studentDataUrl = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/studentData.json`;
            const studentDataResponse = await fetch(studentDataUrl);
            const studentData = await studentDataResponse.json();

            if (!studentData[studentSerialNo]) {
              console.error("No student data found for Serial No:", studentSerialNo);
              return;
            }

            const fullname =
              `${studentData[studentSerialNo].stdName} ${studentData[studentSerialNo].stdFather || ''} ${studentData[studentSerialNo].stdSurname || ''}`.trim();

            console.log("Student Full Name:", fullname);
            setSearchInput(fullname);
            setStdType(fullname);
            setSelectedClass(studentData[studentSerialNo]?.currentClass || "N/A");
            setSelectedDivision(studentData[studentSerialNo]?.division || "N/A");
            setSelectedRegisterNo(studentData[studentSerialNo]?.registerNo || "N/A");
            setSelectedStudentSerialNo(studentSerialNo);
            setTableData(formattedFeeData);

            console.log("Formatted Fee Data Updated:", formattedFeeData);
            console.log("formattedFeeData[0].date ", formattedFeeData[0].date);

            const reportData = {
              studentName: fullname,
              studentClass: studentData[studentSerialNo]?.currentClass || "N/A",
              studentDivision: studentData[studentSerialNo]?.division || "N/A",
              pavatiNo: myinvoiceNumber,
              // date: studentFeeData[feetype]?.date || "N/A",
              date: formattedFeeData[0].date || "N/A",
              // year: studentData[studentSerialNo]?.year || "N/A",
              year: formattedFeeData[0]?.year || "N/A",
              currentInvoiceNo: myinvoiceNumber,
              registerNo: studentData[studentSerialNo]?.registerNo || "N/A",
              feeDetails: formattedFeeData,
              previousBeforePay: updatebeforePay,
            };

            setReportDataUpdated(reportData);
            console.log("Student Fee Receipt", reportDataUpdated);

            return;
          }
        }
      }
      if (!foundInvoice) {
        console.error(`No fee data found for Invoice No: ${myinvoiceNumber}`);
      }
    } catch (error) {
      console.error("Error fetching fee details:", error);
    }
  };

  const fetchBusFeeFromRootNode = async (serialNo) => {
    try {
      const response = await fetch(`${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/root/${finYear}.json`);
      const busData = await response.json();

      if (!busData) {
        console.log('No bus fee data found.');
        return null;
      }

      // Iterate over all root nodes dynamically
      for (const rootKey in busData) {
        const root = busData[rootKey];

        // Check if the student's serial number exists in the current root node
        if (root.studentSerialNo) {
          for (const key in root.studentSerialNo) {
            if (root.studentSerialNo[key] && Number(key) === serialNo) {
              // Return the bus fee data for the current root node
              return root;
            }
          }
        }
      }

      console.log('No bus fee for the given student serial number.');
      return null;
    } catch (error) {
      console.error('Error fetching bus fee from root node:', error);
      return null;
    }
  };


  const handleDateChange = (e) => {
    const selectedDate = e.target.value;
    const minDate = finYearStartDate; // Now always valid due to useEffect
    const maxDate = finYearEndDate;   // Now always valid due to useEffect

    // Check if the selected date is within the valid range
    if (selectedDate < minDate || selectedDate > maxDate) {
      setAlertMessage(`Please select a date between ${minDate} and ${maxDate}.`);
      setDate(''); // Reset the date input
    } else {
      setDate(selectedDate); // Set the valid date
    }
  };

  // **********************************************************************************************************************************

  const handleClassChange1 = (e) => {
    setSelectedClass(e.target.value);
    setStdType('');
    setSelectedRegisterNo('')
  };

  const handleCheckboxChange = (serialNo) => {
    setSelectedStudentSerials(prevSelected => {
      if (prevSelected.includes(serialNo)) {
        // Remove from selected if already present
        return prevSelected.filter(s => s !== serialNo);
      } else {
        // Add to selected
        return [...prevSelected, serialNo];
      }
    });
  };

  const handleChange1 = (e) => {
    const selectedYear = e.target.value;
    if (selectedYear !== year) {
      setYear(selectedYear);
      setFinYear(selectedYear);
    }
    const [startYear, endYear] = selectedYear.split('-');
    setFinYearStartDate(`${startYear}-04-01`); // Assuming financial year starts on April 1st
    setFinYearEndDate(`${endYear}-03-31`);


  };

  const handleChange2 = (e) => {
    const selectedYear = e.target.value;

    if (!selectedYear) return; // Optional: Early return if no value selected

    // Calculate financial year dates (same as handleChange1)
    const [startYear, endYear] = selectedYear.split('-');
    const startDate = `${startYear}-04-01`; // Financial year starts April 1
    const endDate = `${endYear}-03-31`;     // Financial year ends March 31

    // Update all related states (sync year and finYear)
    setYear(selectedYear);
    setFinYear(selectedYear);
    setFinYearStartDate(startDate);
    setFinYearEndDate(endDate);

    // Optionally update the date to a valid date within the new financial year range
    // (This ensures payments start with a valid date; skip if not needed in main form)
    const today = new Date().toISOString().split('T')[0];
    const currentDate = (today >= startDate && today <= endDate) ? today : startDate;
    setDate(currentDate);
  };
  // Reset related fields on transaction change
  const handleTransactionChange = (e) => {
    const value = e.target.value;
    setTransactionValue(value);
    // Clear all conditional fields on transaction change
    setPaymentGatewayType('');
    setTransactionId('');
    setCheckNo('');
    setCheckDate('');
    setddNo('');
    setdddate('');
  };

  const handleClick = (student) => {
    navigate('/receipt', {
      state: {
        stdName: student.stdName,
        stdFather: student.stdFather,
        stdSurname: student.stdSurname,
        serialNo: student.serialNo,
        rollNo: student.rollNo,
        selectedClass: student.currentClass, // Ensure selectedClass is correctly referenced
        selectedYear: year,
        division: student.division, // Use student.division instead of divisionType
        selectedRegisterNo: student.registerNo, // Use student.registerNo
        tableData: tableData // Ensure tableData is correctly referenced and contains data
      }

    });
    console.log("student", student);
    console.log("Roll No:", student.rollNo);


  };
  const handleClick1 = () => {
    navigate('/pavati');
  };

  const handleRefresh = () => {
    // Reset the state related to the form here instead of reloading the page
    setRoot('');
    setSelectedClass('');
    setSelectedRegisterNo('');
    setSelectedStudentSerials([]);
    // Optionally re-fetch data if needed, or just reset the form fields
  };

  const [loading, setLoading] = useState(false); // Loading state
  const [error, setError] = useState(''); // Error state


  //   const fetchAllStudentFees = async () => {
  //     setLoading(true); // Set loading to true
  //     setError(''); // Reset error state

  //     try {
  //         const response = await fetch(`${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/studentFee/${year}.json`);
  //         console.log("Response:", response);

  //         if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);

  //         const data = await response.json();
  //         console.log("Fetched all student fee data:", data); // Log the fetched data

  //         if (data) {
  //             const studentFeesArray = Object.entries(data).map(([serialNo, fees]) => ({
  //                 serialNo,
  //                 ...fees, // Spread the fees object to include all properties
  //             }));

  //             // setStudentFees(studentFeesArray); // Store all student fees in state
  //             setFilteredData(studentFeesArray); // Initialize filtered data
  //         } else {
  //             console.warn("No data found.");
  //             setFilteredData([]); // Return an empty array if no data found
  //         }
  //     } catch (error) {
  //         console.error("Error fetching data:", error);
  //         setError('Error fetching data'); // Set error message
  //         setFilteredData([]); // Return empty array if there's an error
  //     } finally {
  //         setLoading(false); // Set loading to false after fetch
  //     }
  // };

  // const handleFetchData = async () => {
  //     await fetchAllStudentFees();
  // };

  // Call the function (e.g., in useEffect)
  // useEffect(() => {
  //     handleFetchData();
  // }, []);


  const handlecloseForm = () => {
    setShowFeeTypeForm(false);
    fetchDatafirst()
  }
  // ---------------------------- pending fee part ----------------------------

  const handlePendingFeeForm = () => {
    navigate('/pendingfee')
  }


  // -------------------------------------attach kird with fee-------------------------------

  const [kirdTypes, setKirdTypes] = useState([]); // To store Kird types
  const [selectedKirdType, setSelectedKirdType] = useState(""); // To store selected Kird type
  const [creditKhates, setCreditKhates] = useState([]); // To store credit Khate names
  const [selectedcreditKhate, setselectedCreditKhates] = useState(''); // To store credit Khate names
  const [selecteddebitKhate, setselectedDebitKhates] = useState(''); // To store credit Khate names
  const [debitKhates, setDebitKhates] = useState([]); // To store debit Khate names
  const [showNewReportIcon, setShowNewReportIcon] = useState(false);
  const [isSingleSelected, setIsSingleSelected] = useState(false);
  const [isCombinedSelected, setIsCombinedSelected] = useState(false);
  const [typeofattach, setTypeofattach] = useState('');
  const [hasAttachedFeeData, setHasAttachedFeeData] = useState(false);

  const fetchKirdTypes = async () => {
    const firebaseUrl = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/account/kird.json`;
    try {
      const response = await fetch(firebaseUrl);
      const data = await response.json();
      if (data) {
        const types = Object.keys(data).map(key => ({
          kirdType: key,
          ...data[key],
        }));
        setKirdTypes(types);
      }
    } catch (error) {
      console.error("Error fetching Kird types:", error);
    }
  };

  const handleKirdTypeChange = async (event) => {
    const selectedType = event.target.value;
    setSelectedKirdType(selectedType);

    // Fetch Khate names for the selected Kird type
    const khateUrl = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/account/kird/${selectedType}/${year}/khate.json`;

    try {
      const response = await fetch(khateUrl);
      const khateData = await response.json();

      if (khateData) {
        // Extract khate names and filter out null, undefined, or empty values
        const khateNames = Object.keys(khateData)
          .map(key => khateData[key])
          .filter(khate => khate !== null && khate !== undefined && khate.khate && khate.khate.trim() !== ""); // Filter out invalid khate names      
        setCreditKhates(khateNames.map(khate => khate.khate)); // Assuming all khates are credit
        setDebitKhates(khateNames.map(khate => khate.khate)); // Assuming all khates are debit
      }
    } catch (error) {
      console.error("Error fetching Khate names:", error);
    }

  };

  const handleShowNewReportIcon = () => {
    fetchKirdTypes();
    setShowNewReportIcon(true);
  };

  const handleAttacheChange = (type) => {
    if (type === "singlePavati") {
      setIsSingleSelected(true);
      setIsCombinedSelected(false);
      setTypeofattach("singlePavati"); // Set the type of attachment
    } else if (type === "combinedPavati") {
      setIsSingleSelected(false);
      setIsCombinedSelected(true);
      setTypeofattach("combinedPavati"); // Set the type of attachment
    }
  };

  const handleAttachFeeSubmit = async (e) => {
    e.preventDefault();

    // Safely handle empty values
    const feeAttachData = {
      kirdType: selectedKirdType || '',
      creditKhate: selectedcreditKhate || '',
      debitKhate: selecteddebitKhate || '',
      typeofattach: typeofattach || ''
    };

    try {
      const response = await fetch(`${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/kirdWithFeeattach/${year}.json`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(feeAttachData)
      });

      if (response.ok) {
        await updateKirdWithFeeattachData(feeAttachData);
        setAlertMessage(language === "English" ? "Fee attached successfully!" : "फी यशस्वीरित्या जोडली!");
        setHasAttachedFeeData(true)
      }
    } catch (error) {
      console.error('Error saving fee attach data:', error);
      setAlertMessage(language === "English" ? "Failed to attach fee. Please try again." : "फी जोडण्यात अयशस्वी. कृपया पुन्हा प्रयत्न करा.");
    }
  };

  const handleAttachFeeDelete = async (e) => {
    e.preventDefault();
    const feeAttachData = {
      kirdType: selectedKirdType || '',
      creditKhate: selectedcreditKhate || '',
      debitKhate: selecteddebitKhate || '',
      typeofattach: typeofattach || '',
      id: year // Ensure this is included
    };

    try {
      // Delete from Firebase
      const response = await fetch(`${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/kirdWithFeeattach/${year}.json`, {
        method: 'DELETE',
        headers: { 'Content-Type': 'application/json' },
      });

      if (!response.ok) {
        throw new Error('Failed to delete from Firebase');
      }

      // Delete from IndexedDB
      await deleteKirdWithFeeattachData(feeAttachData);

      setAlertMessage(language === "English" ? "Fee Unlinked with Account successfully!" : "किर्द आणि फी यशस्वीरित्या अनलिंक केले!!");
      setselectedCreditKhates("");
      setselectedDebitKhates("");
      setTypeofattach("");
      setKirdTypes([]);
    } catch (error) {
      console.error('Error deleting fee attach data:', error);
      setAlertMessage(language === "English" ? "Failed to Unlink fee. Please try again." : "फी अनलिंक अयशस्वी. कृपया पुन्हा प्रयत्न करा.");
    }
  };


  const deleteKirdWithFeeattachData = (data) => {
    return new Promise((resolve, reject) => {
      const openRequest = indexedDB.open('SchoolManagementDB', 1);

      openRequest.onerror = (event) => {
        console.error("Error opening IndexedDB:", event.target.error);
        reject(event.target.error);
      };

      openRequest.onsuccess = (event) => {
        const db = event.target.result;
        const transaction = db.transaction(['kirdWithFeeattach'], 'readwrite');
        const objectStore = transaction.objectStore('kirdWithFeeattach');

        // Use the year as the key to delete the entry
        const request = objectStore.delete(data.id); // Ensure data.id is the correct key

        request.onerror = (event) => {
          console.error("Error deleting kirdWithFeeattach in IndexedDB:", event.target.error);
          reject(event.target.error);
        };

        request.onsuccess = () => {
          resolve(true);
        };
      };
    });
  };



  {
    creditKhates?.map?.((khate, index) => (
      <option key={index} value={khate}>{khate}</option>
    ))
  }



  const getKirdWithFeeattachData = () => {
    return new Promise((resolve, reject) => {
      const openRequest = indexedDB.open('SchoolManagementDB', 1);

      openRequest.onerror = (event) => {
        console.error("Error opening IndexedDB:", event.target.error);
        reject(event.target.error);
      };

      openRequest.onsuccess = (event) => {
        const db = event.target.result;
        const transaction = db.transaction(['kirdWithFeeattach'], 'readonly');
        const objectStore = transaction.objectStore('kirdWithFeeattach');

        // Fetch the data using the key
        const getRequest = objectStore.get(year); // Use the year as the key

        getRequest.onerror = (event) => {
          console.error("Error reading kirdWithFeeattach from IndexedDB:", event.target.error);
          reject(event.target.error);
        };

        getRequest.onsuccess = (event) => {
          resolve(event.target.result);
        };
      };
    });
  };


  const updateKirdWithFeeattachData = (data) => {
    return new Promise((resolve, reject) => {
      const openRequest = indexedDB.open('SchoolManagementDB', 1);

      openRequest.onerror = (event) => {
        console.error("Error opening IndexedDB:", event.target.error);
        reject(event.target.error);
      };

      openRequest.onsuccess = (event) => {
        const db = event.target.result;
        const transaction = db.transaction(['kirdWithFeeattach'], 'readwrite');
        const objectStore = transaction.objectStore('kirdWithFeeattach');

        // Ensure the data has an id property
        const dataWithId = {
          id: year, // Use the year as the key, or any unique identifier
          ...data
        };

        const request = objectStore.put(dataWithId); // Use put to add or update

        request.onerror = (event) => {
          console.error("Error updating kirdWithFeeattach in IndexedDB:", event.target.error);
          reject(event.target.error);
        };

        request.onsuccess = () => {
          resolve(true);
        };
      };
    });
  };


  useEffect(() => {
    const fetchKirdWithFeeattachData = async () => {
      try {
        const kirdData = await getKirdWithFeeattachData();
        console.log("Fetched kirdWithFeeattach data from IndexedDB:", kirdData);

        if (kirdData) {
          setSelectedKirdType(kirdData.kirdType || '');
          setselectedCreditKhates(kirdData.creditKhate || '');
          setselectedDebitKhates(kirdData.debitKhate || '');
          setTypeofattach(kirdData.typeofattach || '');

          setIsSingleSelected(kirdData.typeofattach === "singlePavati");
          setIsCombinedSelected(kirdData.typeofattach === "combinedPavati");
        } else {
          console.log("No kirdWithFeeattach data found in IndexedDB.");
        }

        setHasAttachedFeeData(!!kirdData.kirdType || !!kirdData.creditKhate || !!kirdData.debitKhate);

      } catch (error) {
        console.error("Error fetching kirdWithFeeattach data from IndexedDB:", error);
      }
    };

    if (isDefaultYearLoaded) {
      fetchKirdWithFeeattachData();
    }
  }, [udiseNumber, year, isDefaultYearLoaded]); // Add dependencies as needed




  useEffect(() => {
    const fetchKhateForSelectedKirdType = async () => {
      if (selectedKirdType) {
        const khateUrl = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/account/kird/${selectedKirdType}/${year}/khate.json`;
        try {
          const response = await fetch(khateUrl);
          const khateData = await response.json();
          if (khateData) {
            const khateNames = Object.keys(khateData)
              .map(key => khateData[key].khate)
              .filter(khate => khate?.trim());
            setCreditKhates(khateNames);
            setDebitKhates(khateNames);
          }
        } catch (error) {
          console.error("Error fetching Khate names:", error);
        }
      }
    };

    if (isDefaultYearLoaded) {
      fetchKhateForSelectedKirdType();
    }
  }, [selectedKirdType, udiseNumber, year, isDefaultYearLoaded]);




  useEffect(() => {
    const fetchStudentDataFromIndexedDB = async () => {
      const storedSerialNo = localStorage.getItem('selectedStudentSerialNo');
      console.log("storedSerialNo--", storedSerialNo);

      if (storedSerialNo) {
        try {
          const db = await openIndexedDB();
          const transaction = db.transaction(['studentData'], 'readonly');
          const objectStore = transaction.objectStore('studentData');

          // Open a cursor to iterate through all records
          const request = objectStore.openCursor();

          request.onsuccess = (event) => {
            const cursor = event.target.result;
            if (cursor) {
              const key = cursor.key;
              console.log("key", key);

              // Check if the key ends with the storedSerialNo
              if (typeof key === 'string' && key.endsWith(`-${storedSerialNo}`)) {
                const studentData = cursor.value;
                console.log("Found matching student:", studentData);

                setStdType(
                  `${studentData.stdName || ''} ${studentData.stdFather || ''} ${studentData.stdSurname || ''}`.trim()
                );
                setSelectedClass(studentData.currentClass || '');
                setSelectedRegisterNo(studentData.registerNo || '');
                setSelectedDivision(studentData.division || '');
                setSelectedStudentSerialNo(storedSerialNo);
                setSelectedStudentSerialforcolor(storedSerialNo);
              } else {
                // Continue to next record
                cursor.continue();
              }
            } else {
              // No more records - student not found

              clearStudentFields();
            }
          };

          request.onerror = (event) => {
            // console.error('Error fetching student data:', event.target.error);
            setAlertMessage('Error fetching student data. Please try again.');
          };
        } catch (error) {
          console.error('Error accessing IndexedDB:', error);
          setAlertMessage('Error accessing student data. Please try again.');
        }
      } else {
        console.log('No selectedStudentSerialNo found ');
      }
    };



    // Helper function to clear student fields
    const clearStudentFields = () => {
      setStdType('');
      setSelectedClass('');
      setSelectedRegisterNo('');
      setSelectedDivision('');
      setSelectedStudentSerialNo('');
      setSelectedStudentSerialforcolor(null);
    };

    if (isDefaultYearLoaded) {
      fetchStudentDataFromIndexedDB();
    }
  }, [udiseNumber, year, isDefaultYearLoaded]);


  return (
    <>
      <div className='main-content-of-page'>
        <AlertMessage message={alertMessage} show={showAlert} />
        <h3 className='text-center my-3' style={{ color: '#03365e', fontWeight: '600', }}>{language === "English" ? " Students Fee " : "विद्यार्थ्यांची फी "}</h3>

        <form onSubmit={editIndex !== null ? handleUpdate : handleSubmit} style={formStyle}>
          <div style={boxContainerStyle}>

            <div style={boxStyle}>
              <label htmlFor="finYear" style={labelStyle1}>{language === "English" ? "Financial Year " : "आर्थिक वर्ष"}:</label>
              <select
                style={{ ...selectStyle, padding: '0' }}
                id="finYear"
                value={finYear}
                onChange={handleChange2}
                required  >
                <option value=""> {language === "English" ? "Select Year " : "वर्ष निवडा"}</option>
                <option value="2019-2020">2019-2020</option>
                <option value="2020-2021">2020-2021</option>
                <option value="2021-2022">2021-2022</option>
                <option value="2022-2023">2022-2023</option>
                <option value="2023-2024">2023-2024</option>
                <option value="2024-2025">2024-2025</option>
                <option value="2025-2026">2025-2026</option>
                <option value="2026-2027">2026-2027</option>
                <option value="2027-2028">2027-2028</option>
                <option value="2028-2029">2028-2029</option>
              </select>
            </div>

            <div style={boxStyle}>
              <label htmlFor="feetype" style={labelStyle1}>Feetype:</label>
              <input
                style={inputStyle}
                type="text"
                id="feetype"
                value={schoolBus ? 'Bus Fee' : getBaseFeetype(feetype)}
                onChange={(e) => setFeetype(e.target.value)}
                disabled={schoolBus}
                required
              />
            </div>
            <div style={boxStyle}>
              <label htmlFor="amount" style={labelStyle1}>{language === "English" ? " Amount " : "रक्कम "} :</label>
              <input
                style={inputStyle}
                type="number"
                id="amount"
                value={schoolBus ? '' : amount}
                onChange={(e) => setAmount(e.target.value)} // Ensure this is present
                disabled={schoolBus}
              />
            </div>
            <div style={boxStyle}>
              <label htmlFor="classType" style={labelStyle1}>{language === "English" ? " Class " : "वर्ग "}  :</label>
              <select
                style={{ ...selectStyle, padding: '0' }}
                id="classType"
                value={classType}
                onChange={(e) => setClassType(e.target.value)}
                required
                disabled={schoolBus}
              >
                <option value="">{language === "English" ? " Select Class " : "वर्ग निवडा "}</option>
                {Array.isArray(classes) && sortClasses(classes.filter(cls => typeof cls === 'string' && cls.trim() !== ""), language).map((cls, index) => (
                  <option key={index} value={cls}>{cls}</option>
                ))}
                <option value="All">All</option>
              </select>
            </div>

            <div >
              <label style={{ ...labelStyle1, marginTop: '30px' }}>
                <input
                  style={checkboxInputStyle}
                  type="checkbox"
                  name="schoolBus"
                  checked={schoolBus}
                  onChange={() => {
                    setSchoolBus(!schoolBus);
                    if (!schoolBus) {
                      setFeetype('Bus Fee');
                      setAmount('');
                      setClassType('All');
                    } else {
                      setFeetype('');
                      setAmount('');
                      setClassType('');
                    }
                  }}
                />
                {language === "English" ? "  School Bus " : "स्कूल बस "}
              </label>
            </div>
          </div>

          <div style={{ display: 'flex', justifyContent: 'right', gap: '13px', marginTop: '2%' }}>
            <div>
              <button type="submit" style={{ padding: '10px', backgroundColor: '#4a235a', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer', fontWeight: 'bold', width: '80px', fontSize: '12px' }}>
                {editIndex !== null ? 'Update' : 'Save'}
              </button>
            </div>
            <div>
              <button onClick={handleRootAssign} type="button" style={{ padding: '10px', backgroundColor: '#4a235a', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer', fontWeight: 'bold', width: '115px', fontSize: '12px' }}>
                {language === "English" ? " Root Assign " : "मार्ग नियुक्त करा"}
              </button>
            </div>
            <div>
              <button onClick={handlePendingFeeForm} type="button" style={{ padding: '10px', backgroundColor: '#4a235a', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer', fontWeight: 'bold', width: '115px', fontSize: '12px' }}>
                {language === "English" ? "Individual Fee" : "वैयक्तिक शुल्क"}
              </button>
            </div>
            <div>
              <button type="button" style={{ padding: '10px', backgroundColor: '#4a235a', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer', fontWeight: 'bold', width: '105px', fontSize: '12px' }} onClick={() => setShowFeeTypeForm(!showFeeTypeForm)}>
                {language === "English" ? "Pay Fee" : "फी भरा"}
              </button>
            </div>
          </div>

          <div style={tableContainerStyle}>
            <table style={tableStyle}>
              <thead>
                <tr>
                  <th style={thStyle}>Feetype</th>
                  <th style={thStyle}>Amount</th>
                  <th style={thStyle}>Class</th>
                  <th style={thStyle}>Total Std</th>
                  <th style={thStyle}>Action</th>
                </tr>
              </thead>
              <tbody>
                {tableData.map((row, index) => (
                  <tr key={index}>
                    <td style={tdStyle}>{getBaseFeetype(row.feetype)}</td>
                    <td style={tdStyle}>{row.amount}</td>
                    <td style={tdStyle}>{row.classType}</td>
                    <td style={tdStyle}>{selectedClass === 'All' ? classCounts['All'] : classCounts[row.classType]}</td>
                    <td style={tdStyle}>
                      <button onClick={() => handleDelete(index)} type="button" style={deleteButtonStyle}>
                        <DeleteIcon />
                      </button>
                      <button onClick={() => handleEdit(index)} type="button" style={editButtonStyle}>
                        <EditIcon />
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

        </form>

        {/*--------------------------------------- attach fee with kird form start----------------------------------- */}
        {showNewReportIcon && (
          <>
            <div className="modal1" style={{ zIndex: 9949000 }}>
              <div className="modal-content minority-form" style={{ width: '510px', height: '410px' }}>
                <style jsx>{`
          .addnewkird {
            font-size: 12px;
            margin-bottom: 0px;
            padding-top: 10px;
            float: right;
          }
          Link {
            text-decoration: none;
          }
        `}</style>
                <div
                  style={{
                    position: 'fixed',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    backgroundColor: 'white',
                    padding: '20px',
                    border: '1px solid #ccc',
                    borderRadius: '5px',
                    zIndex: 9949000,
                    width: '460px',
                    height: '360px'
                  }}
                >
                  <button
                    style={{
                      position: 'absolute',
                      top: '-20px',
                      right: '-24px',
                      padding: '5px',
                      fontSize: '18px',
                      border: 'none',
                      backgroundColor: 'red',
                      color: 'white',
                      borderRadius: '50%',
                      height: '24px',
                      paddingTop: '0px'
                    }}
                    onClick={() => setShowNewReportIcon(false)}
                  >
                    <i className="fa-solid fa-xmark"></i>
                  </button>

                  <h6 style={{ textAlign: 'center', marginTop: '-15px', color: 'purple', marginBottom: '15px' }}>
                    {language === "English" ? "Attach Fee with Account" : "किर्द सोबत फी जोडा"}
                  </h6>

                  <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <h6>{language === "English" ? "Select Account Type" : "किर्द प्रकार निवडा"}</h6>
                    <p className='addnewkird'>
                      <Link to={'/kird'}>
                        + {language === "English" ? "New Account Type" : "नवीन किर्द प्रकार "}
                      </Link>
                    </p>
                  </div>

                  <select
                    style={{ height: '35px', padding: '3px', marginBottom: '15px', fontSize: '14px' }}
                    onChange={handleKirdTypeChange}
                    value={selectedKirdType}
                  >
                    <option value="">{language === "English" ? "Select Account " : "किर्द प्रकार निवडा"}</option>
                    {kirdTypes.map((type, index) => (
                      <option key={index} value={type.kirdType}>{type.kirdType}</option>
                    ))}
                  </select>

                  <h6>{language === "English" ? "Credit Legder" : "जमा खाते"}</h6>
                  <select
                    value={selectedcreditKhate}
                    onChange={(e) => setselectedCreditKhates(e.target.value)}
                    style={{ height: '35px', padding: '3px', marginBottom: '15px', fontSize: '14px' }}
                  >
                    <option value="">{language === "English" ? "Select Credit Khate" : "जमा खाते निवडा"}</option>
                    {creditKhates.map((khate, index) => (
                      <option key={index} value={khate}>{khate}</option>
                    ))}
                  </select>

                  {/* Conditionally show Debit Ledger */}
                  {isSingleSelected && (
                    <>
                      <h6>{language === "English" ? "Debit Ledger (Optional)" : "नावे खाते (पर्यायी)"}</h6>
                      <select
                        value={selecteddebitKhate}
                        onChange={(e) => setselectedDebitKhates(e.target.value)}
                        style={{ height: '35px', padding: '3px', fontSize: '14px' }}
                      >
                        <option value="">{language === "English" ? "Select Debit Khate" : "नावे खाते निवडा"}</option>
                        {debitKhates.map((khate, index) => (
                          <option key={index} value={khate}>{khate}</option>
                        ))}
                      </select>
                    </>
                  )}

                  <div style={{ marginTop: '12px' }}>
                    <div style={{ display: 'flex', gap: '10px' }}>
                      <input
                        id="single-radio"
                        type="radio"
                        name="attachmentType"
                        value="singlePavati"
                        style={{ width: '15px' }}
                        checked={isSingleSelected}
                        onChange={() => handleAttacheChange("singlePavati")}
                      />
                      <label htmlFor="single-radio" style={{ margin: '0 5px 0 0', fontWeight: '400', color: '#333' }}>
                        {language === "English" ? "Attach Separate Invoices" : "स्वतंत्र पावती जोडा"}
                      </label>
                    </div>

                    <div style={{ display: 'flex', gap: '10px' }}>
                      <input
                        id="combined-radio"
                        type="radio"
                        name="attachmentType"
                        value="combinedPavati"
                        style={{ width: '15px' }}
                        checked={isCombinedSelected}
                        onChange={() => handleAttacheChange("combinedPavati")}
                      />
                      <label htmlFor="combined-radio" style={{ margin: '0 5px 0 0', fontWeight: '400', color: '#333' }}>
                        {language === "English" ? "Attach Combined Datewise Invoice" : "तारखेनुसार एकत्रित पावती जोडा"}
                      </label>
                    </div>
                  </div>

                  <button
                    onClick={handleAttachFeeSubmit}
                    style={{ height: '30px', padding: '3px', width: '60px', borderRadius: '4px', marginTop: '8px' }}
                  >
                    Save
                  </button>

                  {hasAttachedFeeData && (
                    <button
                      onClick={handleAttachFeeDelete}
                      style={{
                        height: '30px',
                        padding: '3px',
                        width: '60px',
                        borderRadius: '4px',
                        marginTop: '8px',
                        float: 'Right',
                        right: '0'
                      }}
                    >
                      Unlink
                    </button>
                  )}
                </div>
              </div>
            </div>
          </>
        )}

        {/*--------------------------------------- attach fee with kird form end ------------------------------------- */}

        <div>
          <div>  {showFeeTypeForm && (
            <form key={formKey} style={modalFormStyle1}>
              <button
                type="button"
                onClick={handlecloseForm}
                style={{ ...closeButtonStyle, position: 'absolute', top: '17px', right: '22px', padding: '0px', height: '30px', width: '30px' }}
              >
                &times;
              </button>

              <div style={boxContainerStyle1}>
                <div style={boxStyle1}>
                  <label htmlFor="year" style={{ color: '#4a235a', fontSize: '15px', marginBottom: '-5px', marginRight: '5px', fontWeight: 'bold', }}> {language === "English" ? "Financial Year " : "आर्थिक वर्ष"}</label>
                  <select
                    style={{ height: '32px', marginTop: '5px', fontSize: '14px', padding: '0', minWidth: '60px', borderRadius: '2px' }}
                    id="year"
                    value={year}
                    onChange={handleChange1}
                    required >
                    <option value=""> {language === "English" ? "Select Year " : "वर्ष निवडा"}</option>
                    <option value="2019-2020">2019-2020</option>
                    <option value="2020-2021">2020-2021</option>
                    <option value="2021-2022">2021-2022</option>
                    <option value="2022-2023">2022-2023</option>
                    <option value="2023-2024">2023-2024</option>
                    <option value="2024-2025">2024-2025</option>
                    <option value="2025-2026">2025-2026</option>
                    <option value="2026-2027">2026-2027</option>
                    <option value="2027-2028">2027-2028</option>
                  </select>
                </div>

                <div style={boxStyle1}>
                  <label htmlFor="date" style={{ color: '#4a235a', fontSize: '15px', marginBottom: '-5px', marginRight: '5px', fontWeight: 'bold', }}>{language === "English" ? "Date " : "तारीख"}</label>

                  <input
                    style={{ height: '30px', marginTop: '5px', fontSize: '13px', width: '115px', padding: '0' }}
                    type="date"
                    id="date"
                    value={date}
                    onChange={handleDateChange} // Use the new handleDateChange function
                    required
                    min={finYearStartDate} // Set minimum date
                    max={finYearEndDate} // Set maximum date
                  />
                </div>


                <div style={boxStyle1}>
                  <label
                    htmlFor="invoiceno"
                    style={{
                      color: '#4a235a',
                      fontSize: '15px',
                      marginBottom: '-17px',
                      marginRight: '5px',
                      fontWeight: 'bold', minWidth: '120px'
                    }}
                  >
                    {language === "English" ? "Invoice No" : "पावती क्रमांक"}
                    <p style={{ fontSize: '10px' }}> {language === "English" ? "(Press Enter to Search)" : "(शोधण्यासाठी Enter दाबा)"} </p>
                  </label>
                  <input
                    style={{
                      height: '30px',
                      marginTop: '5px',
                      fontSize: '13px',
                      width: '100px', padding: '0'
                    }}
                    type="text"
                    id="invoiceno"
                    value={invoiceNo}
                    onChange={(e) => setInvoiceNo(e.target.value)}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter') {
                        e.preventDefault();
                        fetchFeeDetailsByInvoiceNumber(invoiceNo);
                        setShowUpdatedPavatiButton(true); // Trigger the button display
                      }
                    }}
                    onClick={(e) => e.target.focus()}
                  />
                </div>

                <div style={boxStyle2}>
                  <label htmlFor="class" style={{ color: '#4a235a', fontSize: '14px', fontWeight: 'bold', marginTop: '5px' }}>{language === "English" ? "Name " : "नाव "}</label>
                  <input
                    type="text"
                    id="studentName" placeholder='Search By Name'
                    value={searchInput}
                    onChange={(e) => setSearchInput(e.target.value)}
                    style={{ width: '170px', height: '30px', }}
                  />
                  {/* <span style={{ height: '35px', marginTop: '5px' , fontSize: '12px', border :'1px solid #0D0907', minWidth:'100px', borderRadius:'3px', padding:'2px'}} >{stdType}</span> */}


                </div>
                {searchInput && (
                  <ul
                    style={{
                      border: '1px solid #ccc',
                      maxHeight: '150px',
                      overflowY: 'auto',
                      listStyleType: 'none',
                      padding: '0',
                      margin: '0',
                      boxShadow: '0 4px 8px rgba(0,0,0,0.5)',
                      width: 'auto',
                      display: 'inline-block',
                      whiteSpace: 'nowrap',
                      marginTop: '-10px',
                      // optionally adjust marginLeft if needed
                      marginLeft: '-25px',
                    }}
                  >
                    {filteredStudentList.map((student, index) => (
                      <li
                        key={index}
                        onClick={() =>
                          handleStudentClick1(
                            student.stdName,
                            student.stdFather,
                            student.stdSurname,
                            student.division,
                            student.currentClass,
                            student.registerNo,
                            student.serialNo
                          )
                        }
                        style={{
                          padding: '5px 2px',
                          cursor: 'pointer',
                          backgroundColor:
                            selectedStudentSerialforcolor === student.serialNo
                              ? '#e0f7fa'
                              : 'white',
                        }}
                      >
                        {student.stdName} {student.stdFather} {student.stdSurname}
                      </li>
                    ))}
                  </ul>
                )}



                <div onClick={handleClick1} style={{ margin: 'auto', marginTop: '10px', marginRight: '-10px' }}>
                  <img
                    src={report}
                    alt="report.png"
                    style={{ width: '35px', height: 'auto' }}
                    title="All Reports"
                  />
                  <p style={{ fontSize: '10px', marginLeft: '-5px', width: '50px' }}>All Report</p>
                </div>


                <div style={{ margin: 'auto 5px', marginTop: '9px' }}>
                  <img onClick={handleShowNewReportIcon}
                    src={attachment}
                    alt=""
                    style={{ width: '36px', height: 'auto' }}
                    title="Attach Fee with Accounts"
                  />
                  <p style={{ fontSize: '10px' }}>Attach Fee</p>
                </div>


                <div style={{ marginLeft: '-15px' }}>

                  {selectedStudentSerialNo && showUpdatedPavatiButton && (
                    <UpdatedPavati reportDataUpdated={reportDataUpdated} />
                  )}
                </div>



                <div style={{ margin: 'auto 5px', marginBottom: '27px' }}>
                  <button
                    type="button"
                    onClick={handleReload}
                    style={{
                      padding: '3px 5px 5px 5px ',
                      fontSize: '20px',
                      backgroundColor: '#4CAF50',
                      color: 'white',
                      border: 'none',
                      borderRadius: '50%',
                      cursor: 'pointer',
                      transition: 'background-color 0.3s'
                      , position: 'absolute', top: '80px', right: '22px', padding: '0px', height: '30px', width: '30px'
                    }}
                    onMouseEnter={(e) => (e.target.style.backgroundColor = '#45a049')}
                    onMouseLeave={(e) => (e.target.style.backgroundColor = '#4CAF50')}
                  >
                    <i className="fa fa-refresh" aria-hidden="true"></i>
                  </button>
                </div>
              </div>

              <div style={{ border: '1px solid black', width: '100%', height: '84%' }}>
                <div style={boxStyle4}>
                  <div style={{ display: 'flex', gap: '6%' }}>
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                      <label htmlFor="classType" style={{ marginBottom: '1px', color: '#4a235a', fontSize: '15px', fontWeight: 'bold', }}>{language === "English" ? "Class  " : "वर्ग"}</label>
                      <select
                        id="currentClass"
                        value={selectedClass}
                        onChange={handleClassChange1}
                        style={{ marginBottom: '20px', width: '170px', height: '33px', fontSize: '14px', padding: '0' }} // Increase height to 50px
                      >
                        <option value="">{language === "English" ? " Select Class " : "वर्ग निवडा "}</option>
                        {Array.isArray(classes) && sortClasses(classes.filter(cls => typeof cls === 'string' && cls.trim() !== ""), language).map((cls, index) => (
                          <option key={index} value={cls}>{cls}</option>
                        ))}
                        <option value="All">All</option>
                      </select>
                    </div>

                    {/* Division Label and Input */}
                    <div style={{ display: 'flex', flexDirection: 'column', }}>
                      <label htmlFor="division" style={{ marginLeft: '1px', marginTop: '-1px', color: '#4a235a', fontSize: '15px', fontWeight: 'bold', }}>Register No</label>
                      <input
                        type="Number"
                        id="registerNo" placeholder=" Enter Register No"
                        value={selectedRegisterNo}
                        style={{ marginTop: '2px', marginLeft: '0', width: '150px', height: '35px', fontSize: '14px', }}

                        onKeyPress={(e) => {
                          if (e.key == 'Enter') {
                            e.preventDefault();
                            setHasPressedEnter(true);
                          }
                        }}
                        onChange={(e) => setSelectedRegisterNo(e.target.value)}
                      />
                    </div>
                  </div>
                </div>

                <div>
                  <div style={tableContainerStyle1}>
                    <table style={tableStyle1}>
                      <thead>
                        <tr>
                          <th style={thStyle1}>Reg. No</th>
                          <th style={thStyle1}>{language === "English" ? "Student Name " : "विद्यार्थ्याचे नाव"}</th>
                          <th style={thStyle1}>{language === "English" ? "Class " : "वर्ग"}</th>
                          <th style={thStyle1}>{language === "English" ? "Division" : "तुकडी"}</th>
                          <th style={thStyle1}></th>
                        </tr>
                      </thead>
                      <tbody>
                        {filteredStudents.map((student, index) => (
                          <tr key={index} style={{
                            backgroundColor: selectedStudentSerialforcolor === student.serialNo ? '#e0f7fa' : 'transparent',
                          }} onClick={() => handleStudentClick1(student.stdName, student.stdFather, student.stdSurname, student.division, student.currentClass, student.registerNo, student.serialNo)}>
                            <td style={tdStyle1}>{student.registerNo}</td>
                            <td style={tdStyle1}>{student.stdName || ""}{" "}{student.stdFather || ""}{" "}{student.stdSurname || ""}</td>
                            <td style={tdStyle1}>{student.currentClass}</td>
                            <td style={tdStyle1} >{student.division}</td>
                            <td style={tdStyle1}>
                              <FontAwesomeIcon
                                icon={faFileLines}
                                size="2x"
                                color="#2874a6"
                                onClick={() => handleClick(student)}
                                style={{ cursor: 'pointer' }}
                              />
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
                <div style={tableContainerStyle2}>
                  <table style={tableStyle2}>
                    <thead>
                      <tr>
                        <th style={thStyle1}>Feetype</th>
                        <th style={thStyle1}>Amount</th>
                        <th style={thStyle1}>Discount %</th>
                        <th style={thStyle1}>Discount Amount</th>
                        <th style={thStyle1}>Amount After Discount</th>
                        <th style={thStyle1}>Previous Paid Fee</th>
                        <th style={thStyle1}>Pay Amount</th>
                      </tr>
                    </thead>
                    <tbody>
                      {tableData.map((row, index) => {
                        if (row.amount === '' || row.amount === undefined || parseFloat(row.amount) === 0) {
                          return null;
                        }
                        return (
                          <tr key={index}>
                            <td style={tdStyle1}>{getBaseFeetype(row.feetype)}</td>
                            <td style={tdStyle1}>{row.amount}</td>
                            {['discountPercent', 'discountAmount'].map((colName) => (
                              <td
                                key={colName}
                                style={tdStyle1}
                                onClick={() => {
                                  setEditCell({ row: index, col: colName });
                                  if (row[colName] === 0) {
                                    handleInputChange({ target: { value: '' } }, index, colName); // Clear the value
                                  }
                                }}
                              >
                                {editCell.row === index && editCell.col === colName ? (
                                  invoiceNo == mylastInvoiceNo || userstatus === "DKglzhgYFYTDT141414HGCkkgfs22117785YFUTFybnujghhgtghghYFYVNOmC234567Omgkysfgvghyfjhyfvv56764" || invoiceNo == mylastInvoiceNo - 1 || invoiceNo >= mylastInvoiceNo + 1 ? (
                                    <input
                                      type="number"
                                      value={row[colName] || ''}
                                      onChange={(e) => handleInputChange(e, index, colName)}
                                      onBlur={() => setEditCell({ row: null, col: null })}
                                    />
                                  ) : (
                                    <span>{row[colName] || '0'}</span>
                                  )
                                ) : (
                                  <span>{row[colName] || '0'}</span>
                                )}
                              </td>
                            ))}
                            <td style={tdStyle1}>{row.remainingAmount || row.amount}</td>
                            <td style={tdStyle1}> {row.beforePay || '0'}
                            </td>

                            <td
                              style={{
                                ...tdStyle1,
                                backgroundColor: row.isPayAmountError ? '' : 'transparent',
                                color: row.isPayAmountError ? 'white' : 'black',
                              }}
                              onClick={() => {
                                setEditCell({ row: index, col: 'payAmount' });
                                if (row.payAmount === 0) {
                                  handleInputChange({ target: { value: '' } }, index, 'payAmount'); // Clear the value
                                }
                              }}
                            >
                              {editCell.row === index && editCell.col === 'payAmount' ? (
                                invoiceNo == mylastInvoiceNo || userstatus === "DKglzhgYFYTDT141414HGCkkgfs22117785YFUTFybnujghhgtghghYFYVNOmC234567Omgkysfgvghyfjhyfvv56764" || invoiceNo == mylastInvoiceNo - 1 || invoiceNo >= mylastInvoiceNo + 1 ? (
                                  <input
                                    type="number"
                                    value={row.payAmount || ''}
                                    onChange={(e) => handleInputChange(e, index, 'payAmount')}
                                  // onKeyPress={(e) => handleKeyPress(e, index)}
                                  // autoFocus // Automatically focus on the input   
                                  />
                                ) : (
                                  <span>{row.payAmount || '0'}</span>
                                )
                              ) : (
                                <span>{row.payAmount || '0'}</span>
                              )}
                            </td>
                          </tr>
                        );
                      })}
                      <tr>
                        <td style={tdStyle1}><strong>Total</strong></td>
                        <td style={tdStyle1}>{tableData.reduce((sum, row) => sum + parseFloat(row.amount || 0), 0)}</td>
                        <td style={tdStyle1}>{tableData.reduce((sum, row) => sum + parseFloat(row.discountPercent || 0), 0)}</td>
                        <td style={tdStyle1}>{tableData.reduce((sum, row) => sum + parseFloat(row.discountAmount || 0), 0)}</td>

                        <td style={tdStyle1}>{tableData.reduce((sum, row) => sum + parseFloat(row.remainingAmount || row.amount || 0), 0)}</td>
                        <td style={tdStyle1}>{tableData.reduce((sum, row) => sum + parseFloat(row.beforePay || 0), 0)}</td>
                        <td style={tdStyle1}>{tableData.reduce((sum, row) => sum + parseFloat(row.payAmount || 0), 0)}</td>
                      </tr>

                    </tbody>
                  </table>
                </div>

                {transactionValue === "Online" && (
                  <div style={{ display: 'flex', gap: '10px', alignItems: 'center', marginLeft: '14px', marginTop: '0.7%' }}>
                    <label htmlFor="paymentGateway" style={{ fontSize: '14px', fontWeight: 'bold', color: '#4a235a' }}>
                      Pay with UPI
                    </label>

                    <select
                      id="paymentGateway"
                      value={paymentGatewayType}
                      onChange={(e) => setPaymentGatewayType(e.target.value)}

                      style={{ height: '30px', fontSize: '13px', padding: '0', width: '120px' }}>
                      <option value="">Select Option</option>
                      <option value="Google Pay">Google Pay</option>
                      <option value="PhonePe">PhonePe</option>
                      <option value="Amazon Pay">Amazon Pay</option>
                      <option value="Paytm">Paytm</option>
                      <option value="BHIM UPI">BHIM UPI </option>
                      <option value="WhatsApp Pay">WhatsApp Pay </option>
                      <option value="Mobikwik">Mobikwik </option>
                      <option value="Freecharge">Freecharge </option>
                    </select>
                    <label htmlFor="transactionId" style={{ fontSize: '14px', fontWeight: 'bold', color: '#4a235a' }}>
                      Trans. ID:
                    </label>
                    <input
                      type="text"
                      id="transactionId"
                      value={transactionId}
                      onChange={(e) => setTransactionId(e.target.value)}

                      style={{ height: '28px', fontSize: '13px', width: '150px', borderRadius: '7px', border: '1px solid gray' }}
                    />
                  </div>
                )}
                {transactionValue === "Check book" && (
                  <div style={{ display: 'flex', gap: '10px', alignItems: 'center', marginLeft: '20px', marginTop: '0.98%' }}>
                    <label htmlFor="checkNo" style={{ fontSize: '14px', fontWeight: 'bold', color: '#4a235a' }}>
                      {language === "English" ? "Check No:" : "चेक नंबर:"}
                    </label>
                    <input
                      type="text"
                      id="checkNo"
                      value={checkNo}
                      onChange={(e) => setCheckNo(e.target.value)}

                      style={{ height: '28px', fontSize: '13px', width: '140px' }}
                    />
                    <label htmlFor="checkDate" style={{ fontSize: '14px', fontWeight: 'bold', color: '#4a235a', marginLeft: '30px' }}>
                      {language === "English" ? "Check Date:" : "चेक दिनांक:"}
                    </label>
                    <input
                      type="date"
                      id="checkDate"
                      value={checkDate}
                      onChange={(e) => setCheckDate(e.target.value)}

                      style={{ height: '28px', fontSize: '13px', width: '130px' }}
                    />
                  </div>
                )}

                {transactionValue === "By DD" && (
                  <div style={{ display: 'flex', gap: '10px', alignItems: 'center', marginLeft: '20px', marginTop: '0.98%' }}>
                    <label htmlFor="ddNo" style={{ fontSize: '14px', fontWeight: 'bold', color: '#4a235a' }}>
                      DD Number:
                    </label>
                    <input
                      type="text"
                      id="ddNo"
                      value={ddNo}
                      onChange={(e) => setddNo(e.target.value)}

                      style={{ height: '28px', fontSize: '13px', width: '140px' }}
                    />
                    <label htmlFor="dddate" style={{ fontSize: '14px', fontWeight: 'bold', color: '#4a235a', marginLeft: '30px' }}>
                      DD Date
                    </label>
                    <input
                      type="date"
                      id="dddate"
                      value={dddate}
                      onChange={(e) => setdddate(e.target.value)}

                      style={{ height: '28px', fontSize: '13px', width: '130px' }}
                    />
                  </div>
                )}

                <div style={{ display: 'flex' }}>
                  <div style={transactionContainerStyle}>

                    <label htmlFor="transaction" style={{ color: '#4a235a', fontSize: '16px', fontWeight: 'bold', marginRight: '15px' }}>
                      {language === "English" ? "Transaction" : "व्यवहार"} :
                    </label>

                    <select id="transaction" value={transactionValue} onChange={handleTransactionChange}
                      required
                      style={{ height: '30px', fontSize: '13px', width: '120px', padding: '0' }}
                    >
                      <option value="">Select</option>
                      <option value="By Cash">By Cash</option>
                      <option value="Online">Online</option>
                      <option value="Check book">Check book</option>
                      <option value="By DD">By DD</option>
                    </select>




                  </div>
                  <button type="submit" onClick={handleFeeTypeSubmit} style={{ ...transactionContainerStyle, marginLeft: '340px', backgroundColor: '#4a235a', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer', fontWeight: 'bold', width: '75px', fontSize: '16px', padding: '5px' }}>
                    {invoiceNo == mylastInvoiceNo - 1 || invoiceNo < mylastInvoiceNo ? 'Update' : 'Save'}
                  </button>
                  <button 
                    type="button" 
                    onClick={handleSendWhatsAppFeeReminder} 
                    style={{ ...transactionContainerStyle, marginLeft: '430px', backgroundColor: '#0f9d58', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer', fontWeight: 'bold', fontSize: '16px', padding: '5px 10px', display: 'flex', alignItems: 'center', width: '280px' }}
                  >
                    <span role="img" aria-label="whatsapp" style={{ marginRight: '5px' }}>📲</span> Send Fee Reminder on WhatsApp
                  </button>
                </div>
                <div style={saveButtonContainer}>
                  {isloading ? (
                    <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0, 0, 0, 0.1)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 1000, backdropFilter: 'blur(1px)', }}>
                      <img src={loading2} alt="Loading..." style={{ width: '100px', height: '100px' }} />
                    </div>
                  ) : (
                    " "
                  )}
                </div>
              </div>

            </form>
          )}
          </div>
        </div>

        {showRootAssignForm && (
          <div style={modalOverlayStylefee}>
            <form onSubmit={handleRootAssignSubmit} style={modalFormStyle}>
              <h4></h4>
              <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                <button
                  onClick={handleRefresh}
                  style={{
                    fontSize: '20px',
                    color: 'red', padding: '4px 10px', backgroundColor: 'rgba(0, 0, 0, .2)',
                    marginLeft: '10px', // Optional margin for spacing on the left
                  }}
                >
                  <i className="fa fa-refresh" aria-hidden="true"></i>
                </button>

                <button
                  onClick={handleRootAssign1}
                  style={{
                    fontSize: '22px',
                    backgroundColor: '#0dcaf0',
                    borderRadius: '10px',
                    padding: '5px',
                    height: '45px',
                    margin: '0 auto', // Centering the button
                  }}
                >
                  <FontAwesomeIcon icon={faPlus} />
                </button>

                <button
                  type="button"
                  onClick={() => setShowRootAssignForm(false)}
                  style={closeButtonStyle}
                  onMouseEnter={() => setIsHovered(true)}
                  onMouseLeave={() => setIsHovered(false)}
                >
                  &times;
                </button>
              </div>



              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '10px' }}>
                <div style={{ display: 'flex', alignItems: 'center', marginRight: '20px' }}>

                  <label style={{ marginRight: '10px', fontSize: '15px', color: '#4a235a', fontWeight: 'bold' }}>{language === "English" ? "Financial Year" : "आर्थिक वर्ष"}:</label>
                  <select
                    style={{ width: '120px', height: '35px', fontSize: '14px', marginRight: '20px', padding: '0' }}
                    id="finYear"
                    value={finYear}
                    onChange={handleChange2}
                    required  >
                    <option value=""> {language === "English" ? "Select Year" : "वर्ष निवडा"}</option>
                    <option value="2019-2020">2019-2020</option>
                    <option value="2020-2021">2020-2021</option>
                    <option value="2021-2022">2021-2022</option>
                    <option value="2022-2023">2022-2023</option>
                    <option value="2023-2024">2023-2024</option>
                    <option value="2024-2025">2024-2025</option>
                    <option value="2025-2026">2025-2026</option>
                    <option value="2026-2027">2026-2027</option>
                    <option value="2027-2028">2027-2028</option>
                    <option value="2028-2029">2028-2029</option>
                  </select>

                  <label htmlFor="root" style={{ marginRight: '10px', fontSize: '15px', color: '#4a235a', fontWeight: 'bold' }}>
                    {language === "English" ? "Root" : "मार्ग"}
                  </label>
                  <select
                    id="root"
                    value={root}
                    onChange={(e) => setRoot(e.target.value)}
                    style={{ width: '130px', height: '35px', fontSize: '14px', marginRight: '20px', padding: '0' }}
                    required
                  >
                    <option value="">Select</option>
                    {roots.map((item) => (
                      <option key={item.id} value={item.id}>
                        {`${item.fromtheway} - ${item.thewayup}`}
                      </option>
                    ))}
                  </select>

                  <label htmlFor="currentClass" style={{ marginRight: '10px', fontSize: '15px', color: '#4a235a', fontWeight: 'bold' }}>
                    {language === "English" ? "Class:" : "वर्ग:"}
                  </label>
                  <select
                    id="currentClass"
                    value={selectedClass}
                    onChange={handleClassChange}
                    style={{ width: '120px', height: '35px', fontSize: '14px', marginRight: '15px', padding: '0' }}

                  >
                    <option value="">{language === "English" ? " Select Class " : "वर्ग निवडा "}</option>
                    {Array.isArray(classes) && sortClasses(classes.filter(cls => typeof cls === 'string' && cls.trim() !== ""), language).map((cls, index) => (
                      <option key={index} value={cls}>{cls}</option>
                    ))}
                    <option value="All">All</option>
                  </select>
                </div>

                <div style={{ display: 'flex', alignItems: 'center', marginRight: '20px' }}>
                  <label htmlFor="registerNo" style={{ marginRight: '10px', fontSize: '15px', color: '#4a235a', fontWeight: 'bold' }}>
                    Register No:
                  </label>
                  <input
                    style={{ width: '130px', height: '35px', marginRight: '10px', fontSize: '14px' }}
                    type="number"
                    id="registerNo"
                    value={selectedRegisterNo}
                    onChange={(e) => setSelectedRegisterNo(e.target.value)}
                  />
                </div>

                <button type="submit" style={buttonStyle2}>
                  Save
                </button>
              </div>
              <div style={tableContainerStyle}>
                <table style={tableStyle}>
                  <thead>
                    <tr>
                      <th style={thStyle}>
                      </th>
                      <th style={thStyle}>Register No</th>
                      <th style={thStyle}>Class</th>
                      <th style={thStyle}>Student Name</th>
                      <th style={thStyle}>Root</th>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredStudents.length > 0 && filteredStudents.map((student, index) => (
                      <tr key={index}>
                        <td style={tdStyle}>
                          <input
                            type="checkbox"
                            checked={selectedStudentSerials.includes(student.serialNo)}
                            onChange={() => handleCheckboxChange(student.serialNo)}
                          />
                        </td>
                        <td style={tdStyle}>{student.registerNo}</td>
                        <td style={tdStyle}>{student.currentClass}</td>
                        <td style={tdStyle} onClick={() => handleStudentClick(student.currentClass)}>
                          {student.stdName + " " + student.stdFather + " " + student.stdSurname}
                        </td>
                        <td style={tdStyle}>{student.rootDisplay}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </form>
          </div>
        )}

        {showNewAddForm && (
          <>
            <div style={modalOverlayStylefee}>
              <form onSubmit={handleRootAssign2} style={modalFormStyle}>
                <button
                  type="button"
                  onClick={() => setShowNewAddForm(false)}
                  style={closeButtonStyle}
                >
                  &times;
                </button>
                <div>
                </div>
                <h3 className='text-center my-3' style={{ color: '#03365e', fontWeight: '600' }}>
                  {language === "English" ? "Bus Root " : "बस मार्ग "}
                </h3>

                {/* Form Inputs in One Horizontal Line */}
                <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'flex-start', marginTop: '20px' }}>
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <label htmlFor="fromtheway" style={{ marginRight: '10px', fontSize: '15px', color: '#4a235a', fontWeight: 'bold' }}>
                      {language === "English" ? "From The Way" : "मार्ग पासुन"}
                    </label>
                    <input
                      type="text"
                      id="fromtheway"
                      value={fromtheway}
                      onChange={(e) => setFromtheway(e.target.value)}
                      required
                      style={{ width: '180px', height: '35px' }}
                    />
                  </div>

                  <div style={{ display: 'flex', alignItems: 'center', marginLeft: '20px' }}>
                    <label htmlFor="thewayup" style={{ marginRight: '10px', fontSize: '15px', color: '#4a235a', fontWeight: 'bold' }}>
                      {language === "English" ? "The Way Up" : "मार्गापर्यंत"}
                    </label>
                    <input
                      type="text"
                      id="thewayup"
                      value={thewayup}
                      onChange={(e) => setThewayup(e.target.value)}
                      required
                      style={{ width: '180px', height: '35px' }}
                    />
                  </div>

                  <div style={{ display: 'flex', alignItems: 'center', marginLeft: '20px' }}>
                    <label htmlFor="amount" style={{ marginRight: '10px', fontSize: '15px', color: '#4a235a', fontWeight: 'bold' }}>
                      {language === "English" ? "Amount" : "रक्कम"}
                    </label>
                    <input
                      type="number"
                      id="amount"
                      value={amount1}
                      onChange={(e) => {
                        const value = e.target.value;
                        // Check if value is less than or equal to 8 digits
                        if (value.length <= 8) {
                          setAmount1(value);
                        }
                      }}
                      required
                      style={{ width: '180px', height: '35px' }}
                    />
                  </div>
                </div>

                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                  <div style={saveButtonContainer1}>
                    <button
                      type="submit"
                      style={{ ...buttonStyle, fontSize: '16px', padding: '8px 16px' }}
                    >
                      {editMode ? 'Update' : 'Save'}
                    </button>
                  </div>

                  <div>
                    <button
                      type="button"
                      style={{ ...buttonStyle, fontSize: '16px', padding: '8px 16px', marginTop: '20px', marginLeft: '30px' }}
                      onClick={() => setShowDriver(!showDriver)}  >
                      {language === "English" ? "Driver Information >" : "चालक माहिती >"}
                    </button>
                    {showDriver && <Driver finYear={finYear} />}
                  </div>
                </div>

                {/* Table Below the Buttons */}
                <div style={{ overflowY: 'auto', maxHeight: '600px', width: '100%', overflowX: 'hidden' }}>
                  <table style={{
                    width: '100%',
                    tableLayout: 'fixed',
                    border: '2px solid #131212',
                    borderCollapse: 'separate',
                    borderSpacing: '0',
                    marginTop: '3.5%',
                  }}>
                    <thead>
                      <tr>
                        <th style={thStyle}>{language === "English" ? "From The Way" : "मार्ग पासुन"}</th>
                        <th style={thStyle}>{language === "English" ? "The Way Up" : "मार्गापर्यंत"}</th>
                        <th style={thStyle}>{language === "English" ? "Amount" : "रक्कम"}</th>
                        <th style={thStyle}>{language === "English" ? "Action" : "कृती"}</th>
                      </tr>
                    </thead>
                    <tbody>
                      {data.length > 0 ? (
                        data.map((item, index) => (
                          <tr key={item.id}>
                            <td style={tdStyle}>{item.fromtheway}</td>
                            <td style={tdStyle}>{item.thewayup}</td>
                            <td style={tdStyle}>{item.amount1}</td>
                            <td style={tdStyle}>
                              <button
                                onClick={() => handleDelete1(item.id)}
                                type="button"
                                style={deleteButtonStyle}
                              >
                                <DeleteIcon />
                              </button>
                              <button
                                onClick={() => handleEdit1(index)}
                                type="button"
                                style={editButtonStyle}
                              >
                                <EditIcon />
                              </button>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="4">No data available</td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </form>
            </div>
          </>
        )}

      </div>
    </>
  );
};

const formStyle = {
  display: 'flex',
  flexDirection: 'column',
  padding: '20px',
  border: '2.5px solid #131212',
  borderRadius: '8px',
  maxWidth: '80%',
  margin: '0 auto',
  maxHeight: '75vh',
  marginLeft: '10%'
};


const boxContainerStyle = {
  display: 'flex',
  justifyContent: 'center',
  marginBottom: '10px',
};

const boxStyle = {
  display: 'flex',
  flexDirection: 'column',
  marginRight: '10px',
  width: '240px'
};

const labelStyle1 = {
  fontSize: '15px',
  fontWeight: 'bold',
  marginBottom: '8px',   // Add space between label and input

};

const inputStyle = {
  height: '30px',
  width: '200px',
  marginRight: '100px',
};

const selectStyle = {
  height: '30px',
  fontSize: '15px',
  fontWeight: 'bold',
  width: '180px',
};

const checkboxInputStyle = {
  width: '20px',
  marginRight: '5px',
};

const tableStyle = {
  width: '100%',
  borderCollapse: 'collapse',
  marginRight: '20px',
  height: '100%'
};

const thStyle = {
  border: '1px solid #ddd', // Add border to table headers
  padding: '8px', // Reduce padding inside table headers
  textAlign: 'left',
  position: 'sticky', // Make the header sticky
  top: '0', // Stick the header to the top
  backgroundColor: '#5dade2',
  zIndex: 1, // Ensure the header is above the table content
  fontSize: '14px',
};

const tdStyle = {
  border: '1px solid #ddd',
  padding: '8px',
  fontSize: '15px',

};

const buttonStyle = {
  padding: '10px 20px',
  backgroundColor: '#4a235a',
  color: 'white',
  border: 'none',
  borderRadius: '4px',
  cursor: 'pointer',
  fontWeight: 'bold',
  width: '100%',
  fontSize: '12px',
};


const buttonStyle2 = {
  padding: '8px 14px',
  backgroundColor: '#4a235a',
  color: 'white',
  border: 'none',
  borderRadius: '4px',
  cursor: 'pointer',
  fontSize: '16px',
}
const deleteButtonStyle = {
  backgroundColor: 'transparent',
  color: '#800000',
  border: 'none',
  borderRadius: '4px',
  cursor: 'pointer',
  padding: '0',
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
};
const editButtonStyle = {
  backgroundColor: 'transparent',
  color: '#2F4F4F',
  border: 'none',
  borderRadius: '4px',
  cursor: 'pointer',
  padding: '0',
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
};

const saveButtonContainer = {
  textAlign: 'center',
  marginTop: '19px',
  marginLeft: '20px',
};

const saveButtonContainer1 = {
  textAlign: 'center',
  marginTop: '20px',
  marginLeft: '20px',
};

const tableContainerStyle = {
  maxHeight: '90vh',
  overflowY: 'scroll',
  width: '100%',
  overflowX: 'hidden',
  border: '2px solid #131212',
  marginTop: '1%',
};

const modalOverlayStylefee = {
  position: 'fixed',
  top: '8.4%',
  left: '12%',
  right: 0,
  bottom: 2,
  backgroundColor: 'rgba(0, 0, 0, 0.1)',
  backdropFilter: 'blur(2px)',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  zIndex: 1,
  width: '89%',
};

const modalFormStyle = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  position: 'fixed',
  top: '43.5%',
  left: '49.5%',
  transform: 'translate(-50%, -50%)',
  backgroundColor: 'white',
  padding: '20px',
  boxShadow: '0 4px 8px rgba(0,0,0,0.5)',
  zIndex: 1000,
  width: '80%',
  height: '80%',
  border: '1px solid #131212',
  borderRadius: '8px',
};
const modalFormStyle1 = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  position: 'fixed',
  top: '52.5%',
  left: '55%',
  transform: 'translate(-50%, -50%)',
  backgroundColor: 'white',
  padding: '5px 20px',
  boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
  zIndex: 1000,
  width: '80%', // Adjust the width to make the form longer
  height: '85.97%',
  border: '1px solid #131212', // Add this line for the border
};
const boxContainerStyle1 = {
  margin: '10px',
  padding: '10px',
  border: '0.5px solid #131212',
  borderRadius: '5px',
  display: 'flex',
  flexDirection: 'row', // Align items in a single row
  alignItems: 'center', // Align items vertically centered
  width: '100%', // Set the width to 100%
  paddingTop: '-20px',
  gap: '3%',
};
const boxStyle1 = {
  display: 'flex',
  alignItems: 'center',
  marginBottom: '16px', // Optional: Space between each field container

};
const tableContainerStyle1 = {
  overflowX: 'auto', // Horizontal scrolling if needed
  overflowY: 'auto', // Vertical scrolling if content exceeds the height
  marginLeft: '1%', // Ensure the container starts at the left
  width: '38%', // Ensure the container takes full width of its parent
  border: '1px solid black',
  marginTop: '10px',
  height: '54vh',
  paddingBottom: '60px',
  '@media only screen and (maxWidth: 768px)': {
    height: '200px', // Increased height for larger screens
    marginBottom: '40px',
    paddingBottom: '60px'
  },
};


const tableContainerStyle2 = {
  overflowX: 'auto',  // Hides horizontal scrolling
  overflowY: 'auto',    // Enables vertical scrolling if content overflows
  width: '55.3%',         // Ensure this fits your layout needs
  height: '70%',      // Set a specific height for vertical scrolling
  position: 'absolute', // Positioning the container absolutely
  top: '21.6%',           // Align the container to the top
  marginLeft: '40%',     // Ensure proper alignment
  border: '1px solid black',
};
const boxStyle2 = {
  display: 'flex',
  gap: '5px',
  marginBottom: '16px', // Optional: Space below the box
};

const tableStyle1 = {
  width: '100%', // Adjust table width to make it smaller
  borderCollapse: 'collapse', // Ensures borders are collapsed into a single line
  fontSize: '12px', // Decrease font size
};

const thStyle1 = {
  border: '1px solid #ddd', // Add border to table headers
  padding: '8px', // Reduce padding inside table headers
  textAlign: 'left',
  position: 'sticky', // Make the header sticky
  top: '0', // Stick the header to the top
  backgroundColor: '#5dade2', // Set background color for contrast
  zIndex: 1, // Ensure the header is above the table content
  fontSize: '14px', // Increase font size slightly for emphasis
  fontWeight: '700', // Set font weight to maximum strength
  color: 'black',
};

const tdStyle1 = {
  border: '1px solid #ddd', // Add border to table cells
  padding: '5px', // Reduce padding inside table cells
  textAlign: 'left',
  fontSize: '14px',

};
const boxStyle4 = {
  display: 'flex', // Use flexbox layout
  flexDirection: 'row', // Arrange items in a column
  alignItems: 'flex-start', // Align items to the left
  marginBottom: '16px', // Space below the box
  marginTop: '16px', // Space below the box
  marginLeft: '1%', // Ensure the container starts at the left
  gap: '2%',
};
const tableStyle2 = {
  borderCollapse: 'collapse',
  fontSize: '12px',
};
const transactionContainerStyle = {
  position: 'absolute', // Position the transaction dropdown absolutely
  top: '92.8%',
  left: '50%',           // Adjust based on your layout requirements
  zIndex: 1,            // Ensure it's on top of other content
};
export default FeeForm;